webpackJsonp([1],Array(25).concat([
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(546),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(456)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sprintf_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sprintf_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      chart: [],
      datasets: [],
      chart_height: '512px'
    };
  },

  computed: {
    poll: function poll() {
      return this.$store.getters['poll'];
    }
  },
  watch: {
    poll: function poll() {
      if (this.redraw) {
        this.datasets = [];
        this.redraw();
      }
    }
  },
  methods: {
    period_time: function period_time() {
      return this.data.BTC.history.all[1].timestamp - this.data.BTC.history.all[0].timestamp;
    },
    destroy_charts: function destroy_charts() {
      if (this.chart.length !== 0) {
        for (c in this.charts) {
          this.chart[c].destroy();
        }
        this.chart = [];
      }
    },
    add_dataset: function add_dataset(set) {
      var f = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var dataset = {
        backgroundColor: '#fff'
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(dataset, set);

      dataset.lineTension = 0;
      dataset.cubicInterpolationMode = 'default';

      if (f !== null) {
        f(dataset);
      }

      this.datasets.push(dataset);
    },
    draw: function draw(id, config, labels) {
      var _this = this;

      this.destroy_charts();

      var p = $('#' + id).parent();
      p.children().remove();
      p.append('<canvas id="' + id + '" style="height: ' + this.chart_height + ';"></canvas>');

      var cfg = {
        data: {
          labels: labels,
          datasets: this.datasets
        }
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(cfg, config);

      if (!cfg.options.tooltips) {
        cfg.options.tooltips = {
          mode: 'index',
          intersect: false
        };
      }

      if (!cfg.options.hover) {
        cfg.options.hover = {
          mode: 'x',
          intersect: false
        };
      }

      this.$nextTick(function () {
        var ctx = document.getElementById(id).getContext("2d");
        _this.chart.push(new Chart(ctx, cfg));
      });
    },
    find_ts: function find_ts(coin, ts) {
      return this.data[coin].history['all'].find(function (h) {
        return h.timestamp === ts;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sprintf_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sprintf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_humanize_duration__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_humanize_duration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_humanize_duration__);





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    data: function data() {
      return this.$store.getters['data'];
    },
    loaded: function loaded() {
      return this.$store.getters['loaded'];
    },
    error: function error() {
      return this.$store.getters['error'];
    },
    leader: function leader() {
      return this.coin_leader();
    },
    loser: function loser() {
      return this.coin_leader(true);
    },
    leader_ratio: function leader_ratio() {
      return this.sprintf('%.2f', this.data[this.leader].averages['last'].dari / this.data[this.loser].averages['last'].dari);
    },
    leader_ratio_float: function leader_ratio_float() {
      return this.data[this.leader].averages['last'].dari / this.data[this.loser].averages['last'].dari;
    },
    btc_c: function btc_c() {
      return 'rgba(255, 136, 0, 1)';
    },
    btc_cbg: function btc_cbg() {
      return 'rgba(255, 136, 0, 0.1)';
    },
    btc_cbge: function btc_cbge() {
      return 'rgba(255, 136, 0, 0.2)';
    },
    bch_c: function bch_c() {
      return 'rgba(0, 0, 255, 1.0)';
    },
    bch_cbg: function bch_cbg() {
      return 'rgba(0, 0, 255, 0.1)';
    },
    bch_cbge: function bch_cbge() {
      return 'rgba(0, 0, 255, 0.2)';
    },
    preforktarget: function preforktarget() {
      return {
        height: 477792,
        difficulty: 860221984436.22,
        timestamp: 1501153380
      };
    },
    btc_h: function btc_h() {
      return this.$store.getters['btc_h'];
    },
    bch_h: function bch_h() {
      return this.$store.getters['bch_h'];
    },
    split_height: function split_height() {
      return 478558;
    },
    all_timeframe: function all_timeframe() {
      return this.data.BTC.history.all[1].timestamp - this.data.BTC.history.all[0].timestamp;
    }
  },
  methods: {
    sprintf: function sprintf(fmt, val) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_sprintf_js__["sprintf"])(fmt, val);
    },
    numeral: function numeral(fmt, val) {
      return __WEBPACK_IMPORTED_MODULE_0_numeral___default()(val).format(fmt);
    },
    money: function money(val) {
      var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      return decimals ? this.numeral('$0,0.00', val) : this.numeral('$0,0', val);
    },
    coin_leader: function coin_leader() {
      var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return this.data.BTC.averages.last.dari > this.data.BCH.averages.last.dari ? r ? "BCH" : "BTC" : r ? "BTC" : "BCH";
    },
    dari: function dari(coin) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_sprintf_js__["sprintf"])('%.2f', this.data[coin].averages.last.dari);
    },

    // coinbase subsidy in coins at height (BTC and BCH share the halving schedule)
    subsidy: function subsidy(height) {
      return 50 / Math.pow(2, Math.floor(height / 210000));
    },

    // total coins issued by blocks below height
    supply: function supply(height) {
      var coins = 0;
      for (var h = 0, s = 50; h < height; h += 210000, s /= 2) {
        coins += Math.min(210000, height - h) * s;
      }
      return coins;
    },
    fees: function fees(obj) {
      return obj.blocks > 0 && obj.price > 1 ? this.sprintf('%.2f', (obj.reward_avg / 100000000 - this.subsidy(obj.height)) * obj.price) : null;
    },
    lastfee: function lastfee(coin) {
      var last = this.data[coin].averages.last;
      return (last.reward_avg / 100000000 - this.subsidy(last.height)) * last.price;
    },
    ts_coin: function ts_coin(coin, ts) {
      return this.data[coin].history['all'].find(function (h) {
        return h.timestamp === ts;
      });
    },
    next_pct: function next_pct(coin) {
      var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var prev = this.data[coin].retargets.slice(-1)[0];
      var last = this.data[coin].averages.last;

      var mod = last.height % 2016;
      if (mod === 0 || mod === 1) return null;

      var mins = this.estimate(coin, last, true);

      if (mins === null) return null;

      var sec = last.timestamp + mins * 60 - prev.timestamp;
      var normal = 2016 * 600;

      var exp = normal / sec * 100;

      if (factor) {
        return exp > 300 ? 4 : normal / sec;
      }

      return exp > 300 ? 300 : exp < 100 ? exp - 100 : exp;
    },
    estimate: function estimate(coin, obj) {
      var m = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


      if (coin === "BCH" && obj.height > 504100) return null;

      var prev = this.data[coin].retargets.slice(-1)[0];
      var last = obj;

      if (prev === undefined) prev = this.preforktarget;

      var mod = last.height % 2016;
      if (mod === 0 || mod === 1) return null;

      var left = 2016 - mod;
      var blkhr = obj.rate12h / obj.avg_diff * 6;

      var hr = left / blkhr;

      var days = hr / 24;
      var mins = hr * 60;

      if (days > 28) return null;

      return m === false ? this.sprintf('%.2f', days) : mins;
    },
    days: function days(coin) {
      var mins = this.estimate(coin, this.data[coin].averages['last'], true);
      if (mins === null) return '>20 days';
      return __WEBPACK_IMPORTED_MODULE_3_humanize_duration___default()(mins * 60 * 1000, { largest: 2, round: true });
    },
    date: function date(coin) {
      var mins = this.estimate(coin, this.data[coin].averages['last'], true);
      if (mins === null) return 'T.B.D.';

      var when = __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(mins, 'm');

      return when.format('MMM Do, HH:mm');
    },
    next: function next(coin) {
      var change = this.next_pct(coin, true);
      if (change === null) return 'T.B.D.';

      var pct = 0;

      if (change > 1) {
        pct = change === 4 ? 400 : (change - 1) / 1 * 100;
      } else {
        pct = (1 - change) / 1 * 100;
      }

      return change > 1 ? this.sprintf('+%.2f%%', pct) : this.sprintf('-%.2f%%', pct);
    },
    left: function left(coin) {
      var h = this.data[coin].averages.last.height;

      return 2016 - h % 2016;
    },
    coino: function coino(coin) {
      return coin === 'BTC' ? 'BCH' : 'BTC';
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_vue__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_summary_vue__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_summary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_summary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reward_vue__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reward_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_reward_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_blockreward_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_blockreward_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_charts_blockreward_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_charts_fees_vue__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_charts_fees_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_charts_fees_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_charts_opportunity_vue__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_charts_opportunity_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_charts_opportunity_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_charts_dari_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_charts_dari_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_charts_dari_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_charts_algo_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_charts_algo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_charts_algo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_charts_feepct_vue__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_charts_feepct_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_charts_feepct_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_charts_inflation_vue__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_charts_inflation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_charts_inflation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pow_vue__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_pow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_charts_hashrate_vue__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_charts_hashrate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_charts_hashrate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_charts_work_vue__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_charts_work_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_charts_work_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_charts_difficulty_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_charts_difficulty_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_charts_difficulty_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_charts_speed_vue__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_charts_speed_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_charts_speed_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_charts_retarget_vue__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_charts_retarget_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_charts_retarget_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_blocks_vue__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_blocks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_blocks_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_charts_blocktime_vue__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_charts_blocktime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_charts_blocktime_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_charts_blocksize_vue__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_charts_blocksize_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_charts_blocksize_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_charts_cdd_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_charts_cdd_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_charts_cdd_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_charts_height_vue__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_charts_height_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_charts_height_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_tx_vue__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_tx_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_tx_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_charts_txs_vue__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_charts_txs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_charts_txs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_charts_txfee_vue__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_charts_txfee_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_charts_txfee_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_security_vue__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_security_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_security_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_charts_rewrite_fork_vue__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_charts_rewrite_fork_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_charts_rewrite_fork_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_charts_rewrite_chain_vue__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_charts_rewrite_chain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_charts_rewrite_chain_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_pages_hashdari_vue__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_pages_hashdari_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_pages_hashdari_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_charts_coin_daa_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_charts_coin_daa_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_charts_coin_daa_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_charts_coin_btc_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_charts_coin_btc_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_charts_coin_btc_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_contact_vue__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_contact_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_contact_vue__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);








































var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_summary_vue___default.a
  }, {
    path: '/hashdari',
    name: 'hashdari',
    component: __WEBPACK_IMPORTED_MODULE_29__components_pages_hashdari_vue___default.a
  }, {
    path: '/coin/bch',
    name: 'coin.bch',
    component: __WEBPACK_IMPORTED_MODULE_30__components_charts_coin_daa_vue___default.a
  }, {
    path: '/coin/btc',
    name: 'coin.btc',
    component: __WEBPACK_IMPORTED_MODULE_31__components_charts_coin_btc_vue___default.a
  }, {
    path: '/reward',
    name: 'reward',
    component: __WEBPACK_IMPORTED_MODULE_4__components_reward_vue___default.a,
    redirect: { name: 'reward.dari.btc' },
    children: [{
      path: '/reward/dari',
      name: 'reward.dari',
      component: __WEBPACK_IMPORTED_MODULE_8__components_charts_dari_vue___default.a,
      redirect: { name: 'reward.dari.btc' },
      children: [{
        path: '/reward/dari/btc',
        name: 'reward.dari.btc',
        component: __WEBPACK_IMPORTED_MODULE_9__components_charts_algo_vue___default.a,
        props: { coin: 'BTC' }
      }, {
        path: '/reward/dari/bch',
        name: 'reward.dari.bch',
        component: __WEBPACK_IMPORTED_MODULE_9__components_charts_algo_vue___default.a,
        props: { coin: 'BCH' }
      }]
    }, {
      path: '/reward/blocks',
      name: 'reward.blocks',
      component: __WEBPACK_IMPORTED_MODULE_5__components_charts_blockreward_vue___default.a
    }, {
      path: '/reward/fees',
      name: 'reward.fees',
      component: __WEBPACK_IMPORTED_MODULE_6__components_charts_fees_vue___default.a
    }, {
      path: '/reward/opportunity',
      name: 'reward.opportunity',
      redirect: { name: 'home' }
    }, {
      path: '/reward/lossgain',
      name: 'reward.lossgain',
      redirect: { name: 'reward.opportunity' }
    }, {
      path: '/reward/inflation',
      name: 'reward.inflation',
      component: __WEBPACK_IMPORTED_MODULE_11__components_charts_inflation_vue___default.a
    }, {
      path: '/reward/feepct',
      name: 'reward.feepct',
      component: __WEBPACK_IMPORTED_MODULE_10__components_charts_feepct_vue___default.a
    }]
  }, {
    path: '/pow',
    name: 'pow',
    component: __WEBPACK_IMPORTED_MODULE_12__components_pow_vue___default.a,
    redirect: { name: 'pow.hashrateabs' },
    children: [{
      path: '/pow/hashrate',
      name: 'pow.hashrate',
      component: __WEBPACK_IMPORTED_MODULE_13__components_charts_hashrate_vue___default.a
    }, {
      path: '/pow/work',
      name: 'pow.work',
      component: __WEBPACK_IMPORTED_MODULE_14__components_charts_work_vue___default.a
    }, {
      path: '/pow/hashrateabs',
      name: 'pow.hashrateabs',
      redirect: { name: 'pow.hashrate' }
    }, {
      path: '/pow/difficulty',
      name: 'pow.difficulty',
      component: __WEBPACK_IMPORTED_MODULE_15__components_charts_difficulty_vue___default.a
    }, {
      path: '/pow/speed',
      name: 'pow.speed',
      component: __WEBPACK_IMPORTED_MODULE_16__components_charts_speed_vue___default.a
    }, {
      path: '/pow/retarget',
      name: 'pow.retarget',
      component: __WEBPACK_IMPORTED_MODULE_17__components_charts_retarget_vue___default.a
    }]
  }, {
    path: '/blocks',
    name: 'blocks',
    component: __WEBPACK_IMPORTED_MODULE_18__components_blocks_vue___default.a,
    redirect: { name: 'blocks.time' },
    children: [{
      path: '/blocks/time',
      name: 'blocks.time',
      component: __WEBPACK_IMPORTED_MODULE_19__components_charts_blocktime_vue___default.a
    }, {
      path: '/blocks/size',
      name: 'blocks.size',
      component: __WEBPACK_IMPORTED_MODULE_20__components_charts_blocksize_vue___default.a
    }, {
      path: '/blocks/height',
      name: 'blocks.height',
      component: __WEBPACK_IMPORTED_MODULE_22__components_charts_height_vue___default.a
    }, {
      path: '/blocks/cdd',
      name: 'blocks.cdd',
      component: __WEBPACK_IMPORTED_MODULE_21__components_charts_cdd_vue___default.a
    }]
  }, {
    path: '/tx',
    name: 'tx',
    component: __WEBPACK_IMPORTED_MODULE_23__components_tx_vue___default.a,
    redirect: { name: 'tx.txs' },
    children: [{
      path: '/tx/txs',
      name: 'tx.txs',
      component: __WEBPACK_IMPORTED_MODULE_24__components_charts_txs_vue___default.a
    }, {
      path: '/tx/fee',
      name: 'tx.fee',
      component: __WEBPACK_IMPORTED_MODULE_25__components_charts_txfee_vue___default.a
    }]
  }, {
    path: '/security',
    name: 'security',
    component: __WEBPACK_IMPORTED_MODULE_26__components_security_vue___default.a,
    redirect: { name: 'security.fork' },
    children: [{
      path: '/security/fork',
      name: 'security.fork',
      component: __WEBPACK_IMPORTED_MODULE_27__components_charts_rewrite_fork_vue___default.a
    }, {
      path: '/security/chain',
      name: 'security.chain',
      component: __WEBPACK_IMPORTED_MODULE_28__components_charts_rewrite_chain_vue___default.a
    }]
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_32__components_contact_vue___default.a
  }]
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
var _this = this;





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// root state object.
// each Vuex instance is just a single state tree.
var state = {
  data: {},
  loaded: false,
  error: false,
  poll: 21,
  last_poll: 0,
  btc_h: 0,
  bch_h: 0,

  polling: false,
  token: null,

  autorefresh: true,
  visible: true

  // mutations are operations that actually mutates the state.
  // each mutation handler gets the entire state tree as the
  // first argument, followed by additional payload arguments.
  // mutations must be synchronous and can be recorded by plugins
  // for debugging purposes.
};var mutations = {
  data: function data(state, _data) {
    state.loaded = true;
    state.error = false;
    state.data = _data;

    state.btc_h = _data.BTC.averages.last.height;
    state.bch_h = _data.BCH.averages.last.height;
    state.poll += 1;
  },
  polling: function polling(state, p) {
    state.polling = p.isPolling;
    state.token = p.token;
  },
  last_poll: function last_poll(state, last) {
    state.last_poll = last;
  },
  autorefresh: function autorefresh(state, enabled) {
    state.autorefresh = enabled;
  },
  visible: function visible(state, _visible) {
    state.visible = _visible;
  }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
var actions = {
  fix_data: function fix_data(_ref, data) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    if (data.BTC.history.all.length > data.BCH.history.all.length) {
      data.BTC.history.all.pop();
    } else if (data.BTC.history.all.length < data.BCH.history.all.length) {
      data.BCH.history.all.pop();
    }

    commit('data', data);
  },
  reload_data: function reload_data(_ref2) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;
    var last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


    var t = +Date.now() / 1000;
    var antidos = t - t % 60;

    if (last !== null) {
      antidos = 'b' + last.BTC + '-' + last.BCH;
    }

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("/api/" + antidos + '.fake.csv').then(function (resp) {
      dispatch('fix_data', resp.data);
    }).catch(function (err) {
      _this.loaded = false;
      _this.error = err && err.message ? err.message : err;
    });
  },

  get_last: function get_last(_ref3) {
    var state = _ref3.state,
        dispatch = _ref3.dispatch;
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var t = +Date.now() / 1000;
    t = parseInt(t);

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("/api/" + 'last?t=' + t).then(function (resp) {
      if (state.btc_h != resp.data.BTC || state.bch_h != resp.data.BCH) {
        var delay = Math.floor(Math.random() * 2000 + 1);
        if (d === false) {
          delay = 1;
        }

        setTimeout(function () {
          dispatch('reload_data', resp.data);
        }, delay);
      }
    }).catch(function (err) {
      dispatch('reload_data');
    });
  },
  poll_data: function poll_data(_ref4) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        state = _ref4.state;

    if (state.polling === true) return;

    var after = 0;

    var between = +Date.now() / 1000 - state.last_poll;
    if (between < 30) {
      after = (30 - between) * 1000;
    }

    var CancelToken = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.CancelToken;
    var token = CancelToken.source();
    commit('polling', { isPolling: true, token: token });

    setTimeout(function () {
      var t = parseInt(+Date.now() / 1000);
      var pepper = 't=' + parseInt(t);

      state.last_poll = +Date.now() / 1000;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("/api/" + 'poll/last?' + pepper, {
        timeout: 90 * 1000,
        cancelToken: state.token.token
      }).then(function (resp) {
        if (state.btc_h != resp.data.BTC || state.bch_h != resp.data.BCH) {
          dispatch('reload_data', resp.data);
        }
        commit('polling', { isPolling: false, token: null });
        commit('last_poll', 0);
        dispatch('poll_data');
      }).catch(function (err) {
        if (!__WEBPACK_IMPORTED_MODULE_2_axios___default.a.isCancel(err)) {
          commit('polling', { isPolling: false, token: null });
          dispatch('poll_data');
        }
      });
    }, after);
  },
  poll_stop: function poll_stop(_ref5) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        state = _ref5.state;

    if (state.polling && state.token) {
      state.token.cancel('window inactive');
      commit('last_poll', 0);
    }

    commit('polling', { isPolling: false, token: null });
  }

  // getters are functions
};var getters = {
  data: function data(state) {
    return state.data;
  },
  loaded: function loaded(state) {
    return state.loaded;
  },
  error: function error(state) {
    return state.error;
  },
  poll: function poll(state) {
    return state.poll;
  },
  btc_h: function btc_h(state) {
    return state.btc_h;
  },
  bch_h: function bch_h(state) {
    return state.bch_h;
  },
  visible: function visible(state) {
    return state.visible;
  }

  // A Vuex instance is created by combining the state, mutations, actions,
  // and getters.
};/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(474)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(563),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(448)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(537),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sprintf_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sprintf_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      visible: true,
      gone: false
    };
  },

  methods: {
    refresh: function refresh() {
      this.$store.dispatch('get_last');
    },
    notify: function notify(t) {
      this.$notify({
        title: t,
        duration: 5000
      });
    }
  },
  watch: {
    loaded: function loaded() {
      this.$store.dispatch('poll_data');
      //this.$store.dispatch('get_last')
    },
    btc_h: function btc_h(n, o) {
      var _this = this;

      if (o == 0) return;

      var t = 'New BTC block found: #' + n;

      var nw = n - o;

      if (this.gone) {
        if (nw > 1) {
          t = n - o + ' new BTC blocks found since you were last here';
        } else {
          t = n - o + ' new BTC block found since you were last here';
        }
      }

      this.notify(t);

      setTimeout(function () {
        _this.gone = false;
      }, 100);
    },
    bch_h: function bch_h(n, o) {
      var _this2 = this;

      if (o == 0) return;

      var t = 'New BCH block found: #' + n;

      var nw = n - o;

      if (this.gone) {
        if (nw > 1) {
          t = n - o + ' new BCH blocks found since you were last here';
        } else {
          t = n - o + ' new BCH block found since you were last here';
        }
      }

      this.notify(t);

      setTimeout(function () {
        _this2.gone = false;
      }, 100);
    },
    visible: function visible(n, o) {
      var _this3 = this;

      if (n === true) {
        this.refresh();
        this.$store.commit('autorefresh', true);
        this.$store.commit('visible', true);
        //this.$store.dispatch('get_last')
        this.$store.dispatch('poll_data');
        setTimeout(function () {
          _this3.gone = false;
        }, 5000);
      } else {
        //this.$store.commit('autorefresh', false)
        this.$store.commit('visible', false);
        this.$store.dispatch('poll_stop');
        this.gone = true;
      }
    }
  },
  computed: {
    version: function version() {
      return "v0.39.2";
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$store.dispatch('get_last', false);

    if (this.$route.name === null) {
      this.$router.replace({ path: '', redirect: '/' });
    }

    var stateKey,
        eventKey,
        keys = {
      hidden: "visibilitychange",
      webkitHidden: "webkitvisibilitychange",
      mozHidden: "mozvisibilitychange",
      msHidden: "msvisibilitychange"
    };

    for (stateKey in keys) {
      if (stateKey in document) {
        eventKey = keys[stateKey];
        break;
      }
    }

    if (false) {
      document.title = document.title + ' DEV';
    }

    document.addEventListener(eventKey, function (v) {
      _this4.visible = !document[stateKey];
    });
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'blocks'
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'algo',
  props: {
    coin: String
  },
  data: function data() {
    return {
      ts: null,
      blocks: 0,
      dari_low: 0,
      dari_high: 0,
      blocks_min: 0,
      blocks_max: 0,
      interval: 0,
      times: {
        '15': 0,
        '10': 0,
        '7': 0,
        '5': 0,
        '3': 0,
        '2': 0,
        '1': 0,
        '0': 0
      },
      blocks_dari: {
        'vlow': 0,
        'low': 0,
        'norm': 0,
        'high': 0,
        'vhigh': 0
      }
    };
  },
  mounted: function mounted() {
    this.redraw();
  },

  computed: {
    block_times_high: function block_times_high() {
      var t = this.times;
      return this.sprintf('%.2f%%', (t['15'] + t['10'] + t['7']) / this.blocks * 100);
    },
    block_times_norm: function block_times_norm() {
      var t = this.times;
      return this.sprintf('%.2f%%', t['5'] / this.blocks * 100);
    },
    block_times_low: function block_times_low() {
      var t = this.times;
      return this.sprintf('%.2f%%', (t['3'] + t['2'] + t['1'] + t['0']) / this.blocks * 100);
    },
    correcting: function correcting() {
      return this.blocksec > 600 ? 'overcorrecting' : 'undercorrecting';
    },
    correctpct: function correctpct() {
      return this.sprintf('%.2f%%', (this.blocksec > 600 ? this.blocksec / 600 - 1 : 600 / this.blocksec - 1) * 100);
    },
    blocktime: function blocktime() {
      return this.sprintf('%.2f', this.blocksec / 60);
    },
    blocksec: function blocksec() {
      return (__WEBPACK_IMPORTED_MODULE_0_moment___default()().unix() - this.ts) / this.blocks;
    },
    date_from: function date_from() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(this.ts).format('MMM. Do');
    },
    date_to: function date_to() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MMM. Do');
    }
  },
  methods: {
    times_pct: function times_pct(k) {
      var val = this.times[k];
      return val > 0 ? this.sprintf('%.1f%%', val / this.blocks * 100) : '0%';
    },
    dari_pct: function dari_pct(k) {
      var val = this.blocks_dari[k];
      return val > 0 ? this.sprintf('%.1f%%', val / this.blocks * 100) : '0%';
    },
    redraw: function redraw() {
      var _this = this;

      this.blocks_dari = {
        'vlow': 0,
        'low': 0,
        'norm': 0,
        'high': 0,
        'vhigh': 0
      };

      this.times = {
        '15': 0,
        '10': 0,
        '7': 0,
        '5': 0,
        '3': 0,
        '2': 0,
        '1': 0,
        '0': 0
      };

      var ts = 0;
      var d = this.data[this.coin].history['all'];

      if (d[0].timestamp > ts) {
        ts = d[0].timestamp;
      }

      var interval = d[1].timestamp - d[0].timestamp;
      this.interval = interval;

      this.ts = ts;
      this.blocks = this.data[this.coin].history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {
          blocks += obj.blocks;
        }
        return blocks;
      }, 0);

      this.dari_low = this.data[this.coin].history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {

          var btc = _this.ts_coin(_this.coino(_this.coin), obj.timestamp);
          if (btc.dari > obj.dari) {
            blocks += obj.blocks;
          }

          var ratio = btc.dari / obj.dari;
          if (ratio > 1.30) {
            _this.blocks_dari.vlow += obj.blocks;
          } else if (ratio > 1.1) {
            _this.blocks_dari.low += obj.blocks;
          } else if (ratio < 0.7) {
            _this.blocks_dari.vhigh += obj.blocks;
          } else if (ratio < 0.9) {
            _this.blocks_dari.high += obj.blocks;
          } else {
            _this.blocks_dari.norm += obj.blocks;
          }
        }
        return blocks;
      }, 0);

      this.dari_high = this.data[this.coin].history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {

          var btc = _this.ts_coin(_this.coino(_this.coin), obj.timestamp);
          if (btc.dari < obj.dari) {
            blocks += obj.blocks;
          }
        }
        return blocks;
      }, 0);

      this.blocks_min = this.data[this.coin].history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {
          if (obj.blocks < blocks) {
            blocks = obj.blocks;
          }
        }
        return blocks;
      }, 9999999);

      this.blocks_max = this.data[this.coin].history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {
          if (obj.blocks > blocks) {
            blocks = obj.blocks;
          }
        }
        return blocks;
      }, 0);

      this.data[this.coin].history['all'].forEach(function (obj) {
        if (obj.timestamp > ts) {
          if (obj.blocks === 0) {
            _this.times['x'] += 1;
          }

          var min = interval / obj.blocks / 60;

          if (min < 4) {
            _this.times['15'] += obj.blocks;
          } else if (min < 6) {
            _this.times['10'] += obj.blocks;
          } else if (min < 7.5) {
            _this.times['7'] += obj.blocks;
          } else if (min < 15) {
            _this.times['5'] += obj.blocks;
          } else if (min < 20) {
            _this.times['3'] += obj.blocks;
          } else if (min < 30) {
            _this.times['2'] += obj.blocks;
          } else if (min < 60) {
            _this.times['1'] += obj.blocks;
          } else {
            _this.times['0'] += obj.blocks;
          }
        }
      });

      //let ts = d[Math.floor(d.length / 2)].timestamp

      var labels = this.data[this.coin].history['all'].reduce(function (dates, obj) {
        if (obj.timestamp > ts) {
          dates.push(__WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm"));
        }
        return dates;
      }, []);

      var act = function act(vals, obj) {
        if (obj.timestamp > ts) {
          vals.push(obj.blocks > 0 ? _this.sprintf('%.0f', obj.avg_diff) : null);
        }
        return vals;
      };

      var perf = function perf(vals, obj) {
        if (obj.timestamp > ts) {
          //vals.push(obj.blocks > 0 ? this.sprintf('%.0f', obj.ratep) : null)

          var o = _this.tsrate(_this.coino(_this.coin), obj.timestamp);
          if (!o) o = 0;
          vals.push(o ? sprintf('%.2f', obj.ratep / (obj.ratep + o) * 100) : null);
        }
        return vals;
      };

      var dari = function dari(vals, obj) {
        if (obj.timestamp > ts) {
          vals.push(obj.blocks > 0 ? _this.sprintf('%.2f', obj.dari / _this.ts_coin(_this.coino(_this.coin), obj.timestamp).dari) : null);
        }
        return vals;
      };

      var blks = function blks(vals, obj) {
        if (obj.timestamp > ts) {
          //vals.push(obj.blocks > 0 ? this.sprintf('%.2f', (obj.rate3h / obj.avg_diff - 1)) : null)
          vals.push(_this.sprintf('%.2f', 3600 / interval * obj.blocks));
        }
        return vals;
      };

      var blks_hi = function blks_hi(vals, obj) {
        if (obj.timestamp > ts) {
          var rat = obj.dari / _this.ts_coin(_this.coino(_this.coin), obj.timestamp).dari;
          vals.push(rat > 1 ? _this.sprintf('%.2f', obj.blocks) : null);
        }
        return vals;
      };

      var blks_lo = function blks_lo(vals, obj) {
        if (obj.timestamp > ts) {
          var rat = obj.dari / _this.ts_coin(_this.coino(_this.coin), obj.timestamp).dari;
          vals.push(rat <= 1 ? _this.sprintf('%.2f', obj.blocks) : null);
        }
        return vals;
      };

      this.add_dataset({
        type: 'line',
        label: 'Difficulty',
        borderColor: this.bch_c,
        data: this.data[this.coin].history['all'].reduce(act, []),
        spanGaps: true,
        yAxisID: 'diff',
        borderDash: [3, 3]
      }, function (d) {
        d.lineTension = 0.5;
      });

      /*        this.add_dataset({
                type: 'line',
                label: 'Perfect',
                borderColor: '#ff0000',
                data: this.data.BTC.history['all'].reduce(perf, []),
                spanGaps: true,
                yAxisID: 'diff'
              }, (d) => {
                d.lineTension = 0.5
              })*/

      this.add_dataset({
        type: 'line',
        label: 'DARI ratio vs ' + this.coino(this.coin),
        borderColor: '#ff0000',
        fill: false,
        borderWidth: 1,
        data: this.data[this.coin].history['all'].reduce(dari, []),
        yAxisID: 'dari'
      }, function (d) {
        d.lineTension = 0.2;
      });

      this.add_dataset({
        type: 'bar',
        label: 'Blocks/hr',
        backgroundColor: '#eeeeee',
        borderColor: '#eeeeee',
        fill: true,
        borderWidth: 0,
        data: this.data[this.coin].history['all'].reduce(blks, []),
        yAxisID: 'ratio'
      });

      /*        this.add_dataset({
                type: 'bar',
                label: 'Blocks Lo',
                backgroundColor: '#0000ff',
                borderColor: '#eeeeee',
                fill: true,
                borderWidth: 0,
                data: this.data.BTC.history['all'].reduce(blks_lo, []),
                yAxisID: 'ratio'
              })
               this.add_dataset({
                type: 'bar',
                label: 'Blocks Hi',
                backgroundColor: '#00ff00',
                borderColor: '#eeeeee',
                fill: true,
                borderWidth: 0,
                data: this.data.BTC.history['all'].reduce(blks_hi, []),
                yAxisID: 'ratio'
              })*/

      var config = {
        type: 'bar',
        options: {
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Date/Time'
              }
            }],
            yAxes: [{
              id: 'diff',
              display: false,
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'Difficulty'
              },
              ticks: {
                callback: function callback(value, index, values) {
                  return _this.numeral('0,0', value);
                },
                min: 0,
                maxTicksLimit: 10
              }
            }, {
              display: true,
              id: 'ratio',
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: 'Blocks per hour'
              },
              gridLines: {
                color: [null, null, null, null, null, null, null, null, '#666', null, null, null]
              },
              ticks: {
                min: 0,
                max: 30,
                stepSize: 3,
                callback: function callback(val) {
                  return val;
                }
              }
            }, {
              display: true,
              id: 'dari',
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'DARI ratio'
              },
              gridLines: {
                color: [null, null, null, null, null, '#666', null, null, null]
              },
              ticks: {
                min: 0,
                max: 2
              }
            }]
          }
        }
      };

      this.draw('canvas-algo-' + this.coin, config, labels);
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'blocks-reward',
    computed: {
        reward_ratio: function reward_ratio() {
            var data = this.data;
            var leader = this.leader;
            var loser = this.loser;
            return sprintf('%.2f', data[leader].reward_avg / 100000000 * data[leader].price / (data[loser].reward_avg / 100000000 * data[loser].price));
        },
        stats: function stats() {
            var _this = this;

            return {
                header: ['3h', '6h', '12h', '1d', '7d'],
                f: function f(coin, avg) {
                    return _this.money(_this.reward(_this.data[coin].averages[avg]));
                },
                coins: [{
                    coin: 'BTC',
                    values: ['3h', '6h', '12h', '1d', '7d']
                }, {
                    coin: 'BCH',
                    values: ['3h', '6h', '12h', '1d', '7d']
                }]
            };
        }
    },
    mounted: function mounted() {
        this.redraw();
    },

    methods: {
        reward: function reward(obj) {
            return obj.blocks > 0 && obj.price > 1 ? this.sprintf('%.2f', obj.reward_avg / 100000000 * obj.price) : null;
        },
        redraw: function redraw() {
            var _this2 = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'BTC',
                backgroundColor: this.btc_cbg,
                borderColor: this.btc_c,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return _this2.reward(obj);
                }),
                fill: true
            });

            this.add_dataset({
                label: 'BCH',
                backgroundColor: this.bch_cbg,
                borderColor: this.bch_c,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return _this2.reward(obj);
                }),
                fill: true
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Block reward (USD)'
                            },
                            ticks: {
                                callback: function callback(value, index, values) {
                                    return _this2.money(value);
                                }
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-reward', config, labels);
        }
    }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sprintf_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sprintf_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'blocks-size',
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        this.redraw();
    },

    computed: {
        stats: function stats() {
            var _this = this;

            return {
                header: ['3h', '6h', '12h', '1d', '7d'],
                f: function f(coin, avg) {
                    return _this.sprintf('%.2f', _this.data[coin].averages[avg].size / 1000);
                },
                coins: [{
                    coin: 'BTC',
                    values: ['3h', '6h', '12h', '1d', '7d']
                }, {
                    coin: 'BCH',
                    values: ['3h', '6h', '12h', '1d', '7d']
                }]
            };
        }
    },
    methods: {
        redraw: function redraw() {
            var _this2 = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'BTC',
                backgroundColor: this.btc_cbg,
                borderColor: this.btc_c,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return _this2.sprintf('%.2f', obj.size / 1000);
                }),
                fill: true
            });

            this.add_dataset({
                label: 'BCH',
                backgroundColor: this.bch_cbg,
                borderColor: this.bch_c,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return obj.blocks > 0 ? _this2.sprintf('%.2f', obj.size / 1000) : null;
                }),
                fill: true
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Avg. blocksize'
                            },
                            ticks: {
                                callback: function callback(value, index, values) {
                                    return value + ' KiB';
                                }
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-blocksize', config, labels);
        }
    },
    destroy: function destroy() {
        this.chart.destroy();
    }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sprintf_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sprintf_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'blocks-time',
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        this.redraw();
    },

    methods: {
        blocks_hr: function blocks_hr(coin, period, min) {
            var obj = this.data[coin].averages[period];
            if (obj.blocks < 1) return '0.00';
            return obj.blocks > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_sprintf_js__["sprintf"])('%.2f', 3600 / (min * 60) * obj.blocks) : null;
        },
        redraw: function redraw() {
            var _this = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            var t = this.period_time();
            var blocktime = function blocktime(obj, coin) {
                var b = 3600 / t * obj.blocks;
                return obj.blocks > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_sprintf_js__["sprintf"])('%.2f', b) : 0;
            };

            var btc_data = this.data.BTC.history['all'].map(function (obj) {
                return blocktime(obj, 'BTC');
            });
            var bch_data = this.data.BCH.history['all'].map(function (obj) {
                return blocktime(obj, 'BCH');
            });

            this.add_dataset({
                label: 'BTC',
                borderColor: this.btc_c,
                data: btc_data
            });

            this.add_dataset({
                label: 'BCH',
                borderColor: this.bch_c,
                data: bch_data
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Blocks per hour'
                            },
                            ticks: {
                                callback: function callback(value, index, values) {
                                    if (value != 5 && value != 3 && value < 10 && index % 2) return null;
                                    return _this.sprintf('%.2f', value);
                                }
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-blocktime', config, labels);
        }
    }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'block-cdd',
    mounted: function mounted() {
        this.redraw();
    },

    computed: {
        stats: function stats() {
            var _this = this;

            return {
                header: ['3h', '1d', '7d'],
                f: function f(coin, avg) {
                    return _this.numeral('0,0', _this.cdd(_this.data[coin].averages[avg]));
                },
                coins: [{
                    coin: 'BTC',
                    values: ['3h', '1d', '7d']
                }, {
                    coin: 'BCH',
                    values: ['3h', '1d', '7d']
                }]
            };
        }
    },
    methods: {
        cdd: function cdd(obj) {
            return obj.blocks > 0 ? this.sprintf('%.2f', obj.cdd * obj.blocks) : null;
        },
        redraw: function redraw() {
            var _this2 = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'BTC',
                borderColor: this.btc_c,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return _this2.cdd(obj);
                })
            });

            this.add_dataset({
                label: 'BCH',
                borderColor: this.bch_c,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return _this2.cdd(obj);
                })
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            type: 'logarithmic',
                            scaleLabel: {
                                display: true,
                                labelString: 'Coindays destroyed'
                            },
                            ticks: {
                                callback: function callback(value, index, ticks) {
                                    if (!(index % parseInt(ticks.length / 10))) {
                                        return _this2.numeral('0,0', value);
                                    }
                                }
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-cdd', config, labels);
        }
    }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'daa',
  data: function data() {
    return {
      ts: null,
      blocks: 0,
      dari_low: 0,
      dari_high: 0,
      blocks_min: 0,
      blocks_max: 0,
      interval: 0,
      times: {
        '15': 0,
        '10': 0,
        '7': 0,
        '5': 0,
        '3': 0,
        '2': 0,
        '1': 0,
        '0': 0
      },
      blocks_dari: {
        'vlow': 0,
        'low': 0,
        'norm': 0,
        'high': 0,
        'vhigh': 0
      }
    };
  },
  mounted: function mounted() {
    this.redraw();
  },

  computed: {
    block_times_high: function block_times_high() {
      var t = this.times;
      return this.sprintf('%.2f%%', (t['15'] + t['10'] + t['7']) / this.blocks * 100);
    },
    block_times_norm: function block_times_norm() {
      var t = this.times;
      return this.sprintf('%.2f%%', t['5'] / this.blocks * 100);
    },
    block_times_low: function block_times_low() {
      var t = this.times;
      return this.sprintf('%.2f%%', (t['3'] + t['2'] + t['1'] + t['0']) / this.blocks * 100);
    },
    correcting: function correcting() {
      return this.blocksec > 600 ? 'overcorrecting' : 'undercorrecting';
    },
    correctpct: function correctpct() {
      return this.sprintf('%.2f%%', (this.blocksec > 600 ? this.blocksec / 600 - 1 : 600 / this.blocksec - 1) * 100);
    },
    blocktime: function blocktime() {
      return this.sprintf('%.2f', this.blocksec / 60);
    },
    blocksec: function blocksec() {
      return (__WEBPACK_IMPORTED_MODULE_0_moment___default()().unix() - this.ts) / this.blocks;
    },
    date_from: function date_from() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(this.ts).format('MMM. Do');
    },
    date_to: function date_to() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MMM. Do');
    }
  },
  methods: {
    times_pct: function times_pct(k) {
      var val = this.times[k];
      return val > 0 ? this.sprintf('%.1f%%', val / this.blocks * 100) : '0%';
    },
    dari_pct: function dari_pct(k) {
      var val = this.blocks_dari[k];
      return val > 0 ? this.sprintf('%.1f%%', val / this.blocks * 100) : '0%';
    },
    redraw: function redraw() {
      var _this = this;

      this.blocks_dari = {
        'vlow': 0,
        'low': 0,
        'norm': 0,
        'high': 0,
        'vhigh': 0
      };

      this.times = {
        '15': 0,
        '10': 0,
        '7': 0,
        '5': 0,
        '3': 0,
        '2': 0,
        '1': 0,
        '0': 0
      };

      var ts = 1510602000;
      var d = this.data.BTC.history['all'];

      if (d[0].timestamp > ts) {
        ts = d[0].timestamp;
      }

      var interval = d[1].timestamp - d[0].timestamp;
      this.interval = interval;

      this.ts = ts;
      this.blocks = this.data.BTC.history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {
          blocks += obj.blocks;
        }
        return blocks;
      }, 0);

      this.dari_low = this.data.BTC.history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {

          var btc = _this.ts_coin("BCH", obj.timestamp);
          if (btc.dari > obj.dari) {
            blocks += obj.blocks;
          }

          var ratio = btc.dari / obj.dari;
          if (ratio > 1.30) {
            _this.blocks_dari.vlow += obj.blocks;
          } else if (ratio > 1.1) {
            _this.blocks_dari.low += obj.blocks;
          } else if (ratio < 0.7) {
            _this.blocks_dari.vhigh += obj.blocks;
          } else if (ratio < 0.9) {
            _this.blocks_dari.high += obj.blocks;
          } else {
            _this.blocks_dari.norm += obj.blocks;
          }
        }
        return blocks;
      }, 0);

      this.dari_high = this.data.BTC.history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {

          var btc = _this.ts_coin("BCH", obj.timestamp);
          if (btc.dari < obj.dari) {
            blocks += obj.blocks;
          }
        }
        return blocks;
      }, 0);

      this.blocks_min = this.data.BTC.history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {
          if (obj.blocks < blocks) {
            blocks = obj.blocks;
          }
        }
        return blocks;
      }, 9999999);

      this.blocks_max = this.data.BTC.history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {
          if (obj.blocks > blocks) {
            blocks = obj.blocks;
          }
        }
        return blocks;
      }, 0);

      this.data.BTC.history['all'].forEach(function (obj) {
        if (obj.timestamp > ts) {
          if (obj.blocks === 0) {
            _this.times['x'] += 1;
          }

          var min = interval / obj.blocks / 60;

          if (min < 4) {
            _this.times['15'] += obj.blocks;
          } else if (min < 6) {
            _this.times['10'] += obj.blocks;
          } else if (min < 7.5) {
            _this.times['7'] += obj.blocks;
          } else if (min < 15) {
            _this.times['5'] += obj.blocks;
          } else if (min < 20) {
            _this.times['3'] += obj.blocks;
          } else if (min < 30) {
            _this.times['2'] += obj.blocks;
          } else if (min < 60) {
            _this.times['1'] += obj.blocks;
          } else {
            _this.times['0'] += obj.blocks;
          }
        }
      });

      //let ts = d[Math.floor(d.length / 2)].timestamp

      var labels = this.data.BTC.history['all'].reduce(function (dates, obj) {
        if (obj.timestamp > ts) {
          dates.push(__WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm"));
        }
        return dates;
      }, []);

      var act = function act(vals, obj) {
        if (obj.timestamp > ts) {
          vals.push(obj.blocks > 0 ? _this.sprintf('%.0f', obj.avg_diff) : null);
        }
        return vals;
      };

      var perf = function perf(vals, obj) {
        if (obj.timestamp > ts) {
          //vals.push(obj.blocks > 0 ? this.sprintf('%.0f', obj.ratep) : null)

          var o = _this.tsrate('BCH', obj.timestamp);
          if (!o) o = 0;
          vals.push(o ? sprintf('%.2f', obj.ratep / (obj.ratep + o) * 100) : null);
        }
        return vals;
      };

      var dari = function dari(vals, obj) {
        if (obj.timestamp > ts) {
          vals.push(obj.blocks > 0 ? _this.sprintf('%.2f', obj.dari / _this.ts_coin('BCH', obj.timestamp).dari) : null);
        }
        return vals;
      };

      var blks = function blks(vals, obj) {
        if (obj.timestamp > ts) {
          //vals.push(obj.blocks > 0 ? this.sprintf('%.2f', (obj.rate3h / obj.avg_diff - 1)) : null)
          vals.push(_this.sprintf('%.2f', 3600 / interval * obj.blocks));
        }
        return vals;
      };

      var blks_hi = function blks_hi(vals, obj) {
        if (obj.timestamp > ts) {
          var rat = obj.dari / _this.ts_coin('BCH', obj.timestamp).dari;
          vals.push(rat > 1 ? _this.sprintf('%.2f', obj.blocks) : null);
        }
        return vals;
      };

      var blks_lo = function blks_lo(vals, obj) {
        if (obj.timestamp > ts) {
          var rat = obj.dari / _this.ts_coin('BCH', obj.timestamp).dari;
          vals.push(rat <= 1 ? _this.sprintf('%.2f', obj.blocks) : null);
        }
        return vals;
      };

      this.add_dataset({
        type: 'line',
        label: 'Difficulty',
        borderColor: this.bch_c,
        data: this.data.BTC.history['all'].reduce(act, []),
        spanGaps: true,
        yAxisID: 'diff',
        borderDash: [3, 3]
      }, function (d) {
        d.lineTension = 0.5;
      });

      /*        this.add_dataset({
                type: 'line',
                label: 'Perfect',
                borderColor: '#ff0000',
                data: this.data.BTC.history['all'].reduce(perf, []),
                spanGaps: true,
                yAxisID: 'diff'
              }, (d) => {
                d.lineTension = 0.5
              })*/

      this.add_dataset({
        type: 'line',
        label: 'DARI ratio vs BCH',
        borderColor: '#ff0000',
        fill: false,
        borderWidth: 1,
        data: this.data.BTC.history['all'].reduce(dari, []),
        yAxisID: 'dari'
      }, function (d) {
        d.lineTension = 0.2;
      });

      this.add_dataset({
        type: 'bar',
        label: 'Blocks/hr',
        backgroundColor: '#eeeeee',
        borderColor: '#eeeeee',
        fill: true,
        borderWidth: 0,
        data: this.data.BTC.history['all'].reduce(blks, []),
        yAxisID: 'ratio'
      });

      /*        this.add_dataset({
                type: 'bar',
                label: 'Blocks Lo',
                backgroundColor: '#0000ff',
                borderColor: '#eeeeee',
                fill: true,
                borderWidth: 0,
                data: this.data.BTC.history['all'].reduce(blks_lo, []),
                yAxisID: 'ratio'
              })
               this.add_dataset({
                type: 'bar',
                label: 'Blocks Hi',
                backgroundColor: '#00ff00',
                borderColor: '#eeeeee',
                fill: true,
                borderWidth: 0,
                data: this.data.BTC.history['all'].reduce(blks_hi, []),
                yAxisID: 'ratio'
              })*/

      var config = {
        type: 'bar',
        options: {
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Date/Time'
              }
            }],
            yAxes: [{
              id: 'diff',
              display: false,
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'Difficulty'
              },
              ticks: {
                callback: function callback(value, index, values) {
                  return _this.numeral('0,0', value);
                },
                min: 0,
                maxTicksLimit: 10
              }
            }, {
              display: true,
              id: 'ratio',
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: 'Blocks per hour'
              },
              gridLines: {
                color: [null, null, null, null, null, null, null, null, '#666', null, null, null]
              },
              ticks: {
                min: 0,
                max: 30,
                stepSize: 3,
                callback: function callback(val) {
                  return val;
                }
              }
            }, {
              display: true,
              id: 'dari',
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'DARI ratio'
              },
              gridLines: {
                color: [null, null, null, null, null, '#666', null, null, null]
              },
              ticks: {
                min: 0,
                max: 2
              }
            }]
          }
        }
      };

      this.draw('canvas-daa', config, labels);
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'daa',
  data: function data() {
    return {
      ts: null,
      blocks: 0,
      dari_low: 0,
      dari_high: 0,
      blocks_min: 0,
      blocks_max: 0,
      interval: 0,
      times: {
        '15': 0,
        '10': 0,
        '7': 0,
        '5': 0,
        '3': 0,
        '2': 0,
        '1': 0,
        '0': 0
      },
      blocks_dari: {
        'vlow': 0,
        'low': 0,
        'norm': 0,
        'high': 0,
        'vhigh': 0
      }
    };
  },
  mounted: function mounted() {
    this.redraw();
  },

  computed: {
    block_times_high: function block_times_high() {
      var t = this.times;
      return this.sprintf('%.2f%%', (t['15'] + t['10'] + t['7']) / this.blocks * 100);
    },
    block_times_norm: function block_times_norm() {
      var t = this.times;
      return this.sprintf('%.2f%%', t['5'] / this.blocks * 100);
    },
    block_times_low: function block_times_low() {
      var t = this.times;
      return this.sprintf('%.2f%%', (t['3'] + t['2'] + t['1'] + t['0']) / this.blocks * 100);
    },
    correcting: function correcting() {
      return this.blocksec > 600 ? 'overcorrecting' : 'undercorrecting';
    },
    correctpct: function correctpct() {
      return this.sprintf('%.2f%%', (this.blocksec > 600 ? this.blocksec / 600 - 1 : 600 / this.blocksec - 1) * 100);
    },
    blocktime: function blocktime() {
      return this.sprintf('%.2f', this.blocksec / 60);
    },
    blocksec: function blocksec() {
      return (__WEBPACK_IMPORTED_MODULE_0_moment___default()().unix() - this.ts) / this.blocks;
    },
    date_from: function date_from() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(this.ts).format('MMM. Do');
    },
    date_to: function date_to() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('MMM. Do');
    }
  },
  methods: {
    times_pct: function times_pct(k) {
      var val = this.times[k];
      return val > 0 ? this.sprintf('%.1f%%', val / this.blocks * 100) : '0%';
    },
    dari_pct: function dari_pct(k) {
      var val = this.blocks_dari[k];
      return val > 0 ? this.sprintf('%.1f%%', val / this.blocks * 100) : '0%';
    },
    redraw: function redraw() {
      var _this = this;

      this.blocks_dari = {
        'vlow': 0,
        'low': 0,
        'norm': 0,
        'high': 0,
        'vhigh': 0
      };

      this.times = {
        '15': 0,
        '10': 0,
        '7': 0,
        '5': 0,
        '3': 0,
        '2': 0,
        '1': 0,
        '0': 0
      };

      var ts = 1510602000;
      var d = this.data.BCH.history['all'];

      if (d[0].timestamp > ts) {
        ts = d[0].timestamp;
      }

      var interval = d[1].timestamp - d[0].timestamp;
      this.interval = interval;

      this.ts = ts;
      this.blocks = this.data.BCH.history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {
          blocks += obj.blocks;
        }
        return blocks;
      }, 0);

      this.dari_low = this.data.BCH.history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {

          var btc = _this.ts_coin("BTC", obj.timestamp);
          if (btc.dari > obj.dari) {
            blocks += obj.blocks;
          }

          var ratio = btc.dari / obj.dari;
          if (ratio > 1.30) {
            _this.blocks_dari.vlow += obj.blocks;
          } else if (ratio > 1.1) {
            _this.blocks_dari.low += obj.blocks;
          } else if (ratio < 0.7) {
            _this.blocks_dari.vhigh += obj.blocks;
          } else if (ratio < 0.9) {
            _this.blocks_dari.high += obj.blocks;
          } else {
            _this.blocks_dari.norm += obj.blocks;
          }
        }
        return blocks;
      }, 0);

      this.dari_high = this.data.BCH.history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {

          var btc = _this.ts_coin("BTC", obj.timestamp);
          if (btc.dari < obj.dari) {
            blocks += obj.blocks;
          }
        }
        return blocks;
      }, 0);

      this.blocks_min = this.data.BCH.history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {
          if (obj.blocks < blocks) {
            blocks = obj.blocks;
          }
        }
        return blocks;
      }, 9999999);

      this.blocks_max = this.data.BCH.history['all'].reduce(function (blocks, obj) {
        if (obj.timestamp > ts) {
          if (obj.blocks > blocks) {
            blocks = obj.blocks;
          }
        }
        return blocks;
      }, 0);

      this.data.BCH.history['all'].forEach(function (obj) {
        if (obj.timestamp > ts) {
          if (obj.blocks === 0) {
            _this.times['x'] += 1;
          }

          var min = interval / obj.blocks / 60;

          if (min < 4) {
            _this.times['15'] += obj.blocks;
          } else if (min < 6) {
            _this.times['10'] += obj.blocks;
          } else if (min < 7.5) {
            _this.times['7'] += obj.blocks;
          } else if (min < 15) {
            _this.times['5'] += obj.blocks;
          } else if (min < 20) {
            _this.times['3'] += obj.blocks;
          } else if (min < 30) {
            _this.times['2'] += obj.blocks;
          } else if (min < 60) {
            _this.times['1'] += obj.blocks;
          } else {
            _this.times['0'] += obj.blocks;
          }
        }
      });

      //let ts = d[Math.floor(d.length / 2)].timestamp

      var labels = this.data.BCH.history['all'].reduce(function (dates, obj) {
        if (obj.timestamp > ts) {
          dates.push(__WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm"));
        }
        return dates;
      }, []);

      var act = function act(vals, obj) {
        if (obj.timestamp > ts) {
          vals.push(obj.blocks > 0 ? _this.sprintf('%.0f', obj.avg_diff) : null);
        }
        return vals;
      };

      var perf = function perf(vals, obj) {
        if (obj.timestamp > ts) {
          //vals.push(obj.blocks > 0 ? this.sprintf('%.0f', obj.ratep) : null)

          var o = _this.tsrate('BTC', obj.timestamp);
          if (!o) o = 0;
          vals.push(o ? sprintf('%.2f', obj.ratep / (obj.ratep + o) * 100) : null);
        }
        return vals;
      };

      var dari = function dari(vals, obj) {
        if (obj.timestamp > ts) {
          vals.push(obj.blocks > 0 ? _this.sprintf('%.2f', obj.dari / _this.ts_coin('BTC', obj.timestamp).dari) : null);
        }
        return vals;
      };

      var blks = function blks(vals, obj) {
        if (obj.timestamp > ts) {
          //vals.push(obj.blocks > 0 ? this.sprintf('%.2f', (obj.rate3h / obj.avg_diff - 1)) : null)
          vals.push(_this.sprintf('%.2f', 3600 / interval * obj.blocks));
        }
        return vals;
      };

      var blks_hi = function blks_hi(vals, obj) {
        if (obj.timestamp > ts) {
          var rat = obj.dari / _this.ts_coin('BTC', obj.timestamp).dari;
          vals.push(rat > 1 ? _this.sprintf('%.2f', obj.blocks) : null);
        }
        return vals;
      };

      var blks_lo = function blks_lo(vals, obj) {
        if (obj.timestamp > ts) {
          var rat = obj.dari / _this.ts_coin('BTC', obj.timestamp).dari;
          vals.push(rat <= 1 ? _this.sprintf('%.2f', obj.blocks) : null);
        }
        return vals;
      };

      this.add_dataset({
        type: 'line',
        label: 'Difficulty',
        borderColor: this.bch_c,
        data: this.data.BCH.history['all'].reduce(act, []),
        spanGaps: true,
        yAxisID: 'diff',
        borderDash: [3, 3]
      }, function (d) {
        d.lineTension = 0.5;
      });

      /*        this.add_dataset({
                type: 'line',
                label: 'Perfect',
                borderColor: '#ff0000',
                data: this.data.BCH.history['all'].reduce(perf, []),
                spanGaps: true,
                yAxisID: 'diff'
              }, (d) => {
                d.lineTension = 0.5
              })*/

      this.add_dataset({
        type: 'line',
        label: 'DARI ratio vs BTC',
        borderColor: '#ff0000',
        fill: false,
        borderWidth: 1,
        data: this.data.BCH.history['all'].reduce(dari, []),
        yAxisID: 'dari'
      }, function (d) {
        d.lineTension = 0.2;
      });

      this.add_dataset({
        type: 'bar',
        label: 'Blocks/hr',
        backgroundColor: '#eeeeee',
        borderColor: '#eeeeee',
        fill: true,
        borderWidth: 0,
        data: this.data.BCH.history['all'].reduce(blks, []),
        yAxisID: 'ratio'
      });

      /*        this.add_dataset({
                type: 'bar',
                label: 'Blocks Lo',
                backgroundColor: '#0000ff',
                borderColor: '#eeeeee',
                fill: true,
                borderWidth: 0,
                data: this.data.BCH.history['all'].reduce(blks_lo, []),
                yAxisID: 'ratio'
              })
      
              this.add_dataset({
                type: 'bar',
                label: 'Blocks Hi',
                backgroundColor: '#00ff00',
                borderColor: '#eeeeee',
                fill: true,
                borderWidth: 0,
                data: this.data.BCH.history['all'].reduce(blks_hi, []),
                yAxisID: 'ratio'
              })*/

      var config = {
        type: 'bar',
        options: {
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Date/Time'
              }
            }],
            yAxes: [{
              id: 'diff',
              display: false,
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'Difficulty'
              },
              ticks: {
                callback: function callback(value, index, values) {
                  return _this.numeral('0,0', value);
                },
                min: 0,
                maxTicksLimit: 10
              }
            }, {
              display: true,
              id: 'ratio',
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: 'Blocks per hour'
              },
              gridLines: {
                color: [null, null, null, null, null, null, null, null, '#666', null, null, null]
              },
              ticks: {
                min: 0,
                max: 30,
                stepSize: 3,
                callback: function callback(val) {
                  return val;
                }
              }
            }, {
              display: true,
              id: 'dari',
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'DARI ratio'
              },
              gridLines: {
                color: [null, null, null, null, null, '#666', null, null, null]
              },
              ticks: {
                min: 0,
                max: 2
              }
            }]
          }
        }
      };

      this.draw('canvas-daa', config, labels);
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sprintf_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sprintf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__algo_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__algo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__algo_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dari',
  components: {
    algo: __WEBPACK_IMPORTED_MODULE_4__algo_vue___default.a
  },
  mounted: function mounted() {
    this.redraw();
  },

  methods: {
    redraw: function redraw() {
      var _this = this;

      var labels = this.data.BTC.history['all'].map(function (obj) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
      });

      this.add_dataset({
        label: 'BTC',
        borderColor: this.btc_c,
        data: this.data.BTC.history['all'].map(function (obj) {
          return _this.obj_dari(obj);
        }),
        yAxisID: 'dari',
        spanGaps: true
      });

      this.add_dataset({
        label: 'Difficulty',
        borderColor: this.btc_c,
        borderDash: [3, 3],
        data: this.data.BTC.history['all'].map(function (obj) {
          return _this.obj_diff(obj);
        }),
        yAxisID: 'diff',
        spanGaps: true
      });

      this.add_dataset({
        label: 'BCH',
        borderColor: this.bch_c,
        data: this.data.BCH.history['all'].map(function (obj) {
          return _this.obj_dari(obj);
        }),
        yAxisID: 'dari',
        spanGaps: true
      });

      this.add_dataset({
        label: 'Difficulty',
        borderColor: this.bch_c,
        borderDash: [3, 3],
        data: this.data.BCH.history['all'].map(function (obj) {
          return _this.obj_diff(obj);
        }),
        yAxisID: 'diff',
        spanGaps: true
      });

      var config = {
        type: 'line',
        options: {
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Date/Time'
              }
            }],
            yAxes: [{
              display: true,
              id: 'dari',
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'DARI'
              }
            }, {
              display: false,
              id: 'diff',
              scaleLabel: {
                display: true,
                labelString: 'Relative difficulty'
              }
            }]
          }
        }
      };

      this.draw('canvas-dari', config, labels);
    },
    obj_dari: function obj_dari(obj) {
      return obj.blocks > 0 && obj.price > 1 ? this.sprintf('%.2f', obj.dari) : null;
    },
    obj_diff: function obj_diff(obj) {
      return obj.blocks > 0 && obj.price > 1 ? this.sprintf('%.2f', obj.avg_diff / 10000000000) : null;
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pow-difficulty-expected',
    mounted: function mounted() {
        this.redraw();
    },

    methods: {
        expected: function expected(obj) {
            var a = this.ts_coin('BTC', obj.timestamp);
            var b = this.ts_coin('BCH', obj.timestamp);

            if (!a || !b) return null;

            if (b.height < 478600) return null;

            return a.rate7d + b.rate7d;
        },
        actual: function actual(obj) {
            var a = this.ts_coin('BTC', obj.timestamp);
            var b = this.ts_coin('BCH', obj.timestamp);

            if (!a || !b) return null;

            if (b.height < 478600) return null;

            return a.avg_diff + b.avg_diff;
        },
        redraw: function redraw() {
            var _this = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'Expected',
                borderColor: '#000000',
                spanGaps: true,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return _this.expected(obj);
                })
            });

            this.add_dataset({
                label: 'Actual',
                borderColor: '#ff0000',
                spanGaps: true,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return _this.actual(obj);
                })
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Difficulty'
                            },
                            ticks: {
                                callback: function callback(value, index, values) {
                                    return _this.numeral('0,0', value);
                                },
                                min: 800000000000
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-difficulty-expected', config, labels);
        }
    }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__difficulty_expected_vue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__difficulty_expected_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__difficulty_expected_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pow-difficulty',
    components: {
        expected: __WEBPACK_IMPORTED_MODULE_3__difficulty_expected_vue___default.a
    },
    mounted: function mounted() {
        this.redraw();

        if (this.$route.hash === '#exp') {
            location.hash = '';
            this.$nextTick(function () {
                location.hash = '#exp';
            });
        }
    },

    methods: {
        redraw: function redraw() {
            var _this = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            var diff = function diff(obj) {
                return obj.blocks > 0 ? _this.sprintf('%.0f', obj.avg_diff) : null;
            };

            this.add_dataset({
                label: 'BTC',
                borderColor: this.btc_c,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return diff(obj);
                }),
                spanGaps: true
            });

            this.add_dataset({
                label: 'BCH',
                borderColor: this.bch_c,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return diff(obj);
                }),
                spanGaps: true
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Difficulty'
                            },
                            ticks: {
                                callback: function callback(value, index, values) {
                                    return _this.numeral('0,0', value);
                                }
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-difficulty', config, labels);
        }
    }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sprintf_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sprintf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'feemarket-chart',
  mounted: function mounted() {
    this.redraw();
  },
  data: function data() {
    return {
      chart_height: '256px'
    };
  },

  methods: {
    redraw: function redraw() {
      var _this = this;

      var labels = this.data.BTC.summary.fee_market.map(function (obj) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD");
      });

      this.add_dataset({
        type: 'bar',
        fill: true,
        label: 'Fees',
        borderColor: this.btc_c,
        backgroundColor: this.btc_c,
        data: this.data.BTC.summary.fee_market.map(function (obj) {
          return _this.sprintf('%.2f', obj.fees);
        }),
        yAxisID: 'sum'
      });

      this.add_dataset({
        type: 'line',
        label: '%',
        borderColor: this.btc_c,
        borderDash: [3, 3],
        data: this.data.BTC.summary.fee_market.map(function (obj) {
          return _this.sprintf('%.2f', obj.percentage);
        }),
        yAxisID: 'pct'
      }, function (d) {
        d.lineTension = 0.2;
      });

      this.add_dataset({
        type: 'bar',
        fill: true,
        label: 'Fees',
        borderColor: this.bch_c,
        backgroundColor: this.bch_c,
        data: this.data.BCH.summary.fee_market.map(function (obj) {
          return _this.sprintf('%.2f', obj.fees);
        }),
        yAxisID: 'sum'
      });

      this.add_dataset({
        type: 'line',
        label: '%',
        borderColor: this.bch_c,
        borderDash: [3, 3],
        data: this.data.BCH.summary.fee_market.map(function (obj) {
          return _this.sprintf('%.2f', obj.percentage);
        }),
        yAxisID: 'pct'
      }, function (d) {
        d.lineTension = 0.2;
      });

      var config = {
        type: 'bar',
        options: {
          title: {
            display: true,
            text: 'Fee market development (past 30 days)'
          },
          scales: {
            xAxes: [{
              display: true
            }],
            yAxes: [{
              id: 'sum',
              display: true,
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'TX fees per day (USD)'
              },
              ticks: {
                callback: function callback(value, index, values) {
                  return _this.numeral('$0,0', value);

                  var steps = [10000, 100000, 100000, 1000000, 5000000];

                  if (steps.indexOf(value) !== -1) {
                    return _this.numeral('$0,0', value);
                  }
                  return null;
                },
                min: 0,
                maxTicksLimit: 10
              }
            }, {
              display: true,
              id: 'pct',
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: 'Percentage of total reward'
              },
              ticks: {
                callback: function callback(val) {
                  return _this.sprintf('%.0f%%', val);
                }
              }
            }]
          }
        }
      };

      this.draw('canvas-feemarket', config, labels);
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'blocks-feepct',
    mounted: function mounted() {
        this.redraw();
    },

    computed: {
        stats: function stats() {
            var _this = this;

            return {
                header: ['3h', '6h', '12h', '1d', '7d'],
                f: function f(coin, avg) {
                    var p = _this.feepct(_this.data[coin].averages[avg]);
                    if (p === null) return null;
                    return p + '%';
                },
                coins: [{
                    coin: 'BTC',
                    values: ['3h', '6h', '12h', '1d', '7d']
                }, {
                    coin: 'BCH',
                    values: ['3h', '6h', '12h', '1d', '7d']
                }]
            };
        }
    },
    methods: {
        feepct: function feepct(obj) {
            if (obj.blocks < 1 || obj.price < 1) {
                return null;
            }

            var reward = obj.reward_avg / 100000000 * obj.price;
            var fee = (obj.reward_avg / 100000000 - this.subsidy(obj.height)) * obj.price;

            return this.sprintf('%.2f', fee / reward * 100);
        },
        redraw: function redraw() {
            var _this2 = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'BTC',
                backgroundColor: this.btc_cbg,
                borderColor: this.btc_c,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return _this2.feepct(obj);
                }),
                fill: true
            });

            this.add_dataset({
                label: 'BCH',
                backgroundColor: this.bch_cbg,
                borderColor: this.bch_c,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return _this2.feepct(obj);
                }),
                fill: true
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Fee %'
                            },
                            ticks: {
                                callback: function callback(value, index, values) {
                                    return value + '%';
                                }
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-feepct', config, labels);
        }
    }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);


var _name$computed$mounte;

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = (_name$computed$mounte = {
    name: 'reward-fees',
    computed: {
        feediff: function feediff() {
            var btc = this.lastfee('BTC');
            var bch = this.lastfee('BCH');

            return btc / bch;
        }
    },
    mounted: function mounted() {
        this.redraw();
    }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$computed$mounte, 'computed', {
    stats: function stats() {
        var _this = this;

        return {
            header: ['3h', '6h', '12h', '1d', '7d'],
            f: function f(coin, avg) {
                return _this.money(_this.fees(_this.data[coin].averages[avg]));
            },
            coins: [{
                coin: 'BTC',
                values: ['3h', '6h', '12h', '1d', '7d']
            }, {
                coin: 'BCH',
                values: ['3h', '6h', '12h', '1d', '7d']
            }]
        };
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$computed$mounte, 'methods', {
    redraw: function redraw() {
        var _this2 = this;

        var labels = this.data.BTC.history['all'].map(function (obj) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
        });

        this.add_dataset({
            label: 'BTC',
            backgroundColor: this.btc_cbg,
            borderColor: this.btc_c,
            data: this.data.BTC.history['all'].map(function (obj) {
                return _this2.fees(obj);
            }),
            fill: true
        });

        this.add_dataset({
            label: 'BCH',
            backgroundColor: this.bch_cbg,
            borderColor: this.bch_c,
            data: this.data.BCH.history['all'].map(function (obj) {
                return _this2.fees(obj);
            }),
            fill: true
        });

        var config = {
            type: 'line',
            options: {
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Date/Time'
                        }
                    }],
                    yAxes: [{
                        display: true,
                        position: 'right',
                        scaleLabel: {
                            display: true,
                            labelString: 'Fees (USD)'
                        },
                        ticks: {
                            callback: function callback(value, index, values) {
                                return _this2.money(value);
                            }
                        }
                    }]
                }
            }
        };

        this.draw('canvas-fees', config, labels);
    }
}), _name$computed$mounte);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        avg: String
    },
    data: function data() {
        return {};
    },

    computed: {},
    mounted: function mounted() {
        this.redraw();
    },

    methods: {
        hashrate_dari: function hashrate_dari(coin, obj) {
            var o = this.ts_coin(coin === 'BTC' ? 'BCH' : 'BTC', obj.timestamp);

            if (!o) return null;

            if (o.blocks === 0 || obj.blocks === 0) {
                return null;
            }

            if (o.dari > obj.dari) return null;

            var rate = o[this.avg] + obj[this.avg];
            return rate * Math.pow(2, 32) / 600 / Math.pow(10, 18);
        },
        redraw: function redraw() {
            var _this = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'BCH',
                borderColor: this.bch_c,
                backgroundColor: this.bch_cbg,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return _this.hashrate_dari('BCH', obj);
                }),
                pointRadius: 0
            });

            this.add_dataset({
                label: 'BTC',
                borderColor: this.btc_c,
                backgroundColor: this.btc_cbg,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return _this.hashrate_dari('BTC', obj);
                }),
                pointRadius: 0
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            stacked: true,
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Exahashes per second'
                            },
                            ticks: {
                                callback: function callback(value, index, values) {
                                    return _this.sprintf('%.2f', value);
                                }
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-hashrate-dari-' + this.avg, config, labels);
        }
    }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashrateabs_vue__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashrateabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__hashrateabs_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pow-hashrate',
    components: {
        hra: __WEBPACK_IMPORTED_MODULE_3__hashrateabs_vue___default.a
    },
    data: function data() {
        return {
            replacechart: null,
            hashchart: null
        };
    },

    computed: {
        replace_chain: function replace_chain() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration({
                minutes: this.data.BCH.pow.split.work / this.data.BTC.pow.current.work_actual * 10
            }).humanize();
        }
    },
    mounted: function mounted() {
        this.redraw();

        if (this.$route.hash === '#rel') {
            location.hash = '';
            this.$nextTick(function () {
                location.hash = '#rel';
            });
        }
    },

    methods: {
        redraw: function redraw() {
            var _this = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'BCH',
                borderColor: this.bch_cbg,
                backgroundColor: this.bch_cbge,
                data: this.data.BCH.history['all'].map(function (obj) {
                    var o = _this.tsrate('BTC', obj.timestamp);
                    if (!o) o = 0;
                    return o ? sprintf('%.2f', obj.rate3h / (obj.rate3h + o) * 100) : null;
                }),
                fill: true,
                spanGaps: true,
                pointRadius: 0
            });

            this.add_dataset({
                label: 'BTC',
                borderColor: this.btc_cbg,
                backgroundColor: this.btc_cbge,
                data: this.data.BTC.history['all'].map(function (obj) {
                    var o = _this.tsrate('BCH', obj.timestamp);
                    if (!o) o = 0;
                    return o ? sprintf('%.2f', obj.rate3h / (obj.rate3h + o) * 100) : null;
                }),
                fill: '-1',
                spanGaps: true,
                pointRadius: 0
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            stacked: true,
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Hashrate % of total'
                            },
                            ticks: {
                                callback: function callback(value, index, values) {
                                    return value + '';
                                }
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-hashrate', config, labels);
        },
        perct: function perct(coin) {
            var avg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (this.data[coin].averages.last.blocks < 1) return null;
            return sprintf('%.2f%%', this.data[coin].averages['3h']['rate' + avg] / (this.data.BTC.averages['3h']['rate' + avg] + this.data.BCH.averages['3h']['rate' + avg]) * 100);
        },
        tsrate: function tsrate(coin, ts) {
            var o = this.data[coin].history['all'].find(function (h) {
                return h.timestamp === ts;
            });
            return o ? o.rate3h : null;
        }
    }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pow-hashrateabs',
    data: function data() {
        return {
            replacechart: null,
            hashchart: null
        };
    },

    computed: {
        replace_chain: function replace_chain() {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration({
                minutes: this.data.BCH.pow.split.work / this.data.BTC.pow.current.work_actual * 10
            }).humanize();
        }
    },
    mounted: function mounted() {
        this.redraw();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        tsrate: function tsrate(coin, ts) {
            var o = this.data[coin].history['all'].find(function (h) {
                return h.timestamp === ts;
            });
            return o ? o.rate : null;
        },
        redraw: function redraw() {
            var _this = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'BTC',
                borderColor: this.btc_c,
                backgroundColor: this.btc_cbg,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return sprintf('%.2f', obj.rate12h * Math.pow(2, 32) / 600 / Math.pow(10, 18));
                }),
                spanGaps: true,
                pointRadius: 0
            });

            this.add_dataset({
                label: 'BCH',
                borderColor: this.bch_c,
                backgroundColor: this.bch_cbg,
                data: this.data.BCH.history['all'].map(function (obj) {
                    if (obj.rate12h < 1) return null;
                    return sprintf('%.2f', obj.rate12h * Math.pow(2, 32) / 600 / Math.pow(10, 18));
                }),
                spanGaps: true,
                pointRadius: 0
            });

            this.add_dataset({
                label: 'Total',
                borderColor: 'rgba(0,0,0,0.5)',
                borderDash: [3, 3],
                data: this.data.BCH.history['all'].map(function (obj) {
                    if (obj.rate12h < 1) return null;
                    var o = _this.tsrate('BTC', obj.timestamp);
                    return o ? sprintf('%.2f', (obj.rate12h + o) * Math.pow(2, 32) / 600 / Math.pow(10, 18)) : null;
                }),
                spanGaps: true,
                pointRadius: 0
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Exahashes per second'
                            },
                            ticks: {
                                callback: function callback(value, index, values) {
                                    return _this.sprintf('%.2f', value);
                                }
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-hashrateabs', config, labels);
        },
        abs: function abs(coin) {
            var avg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (this.data[coin].averages.last.blocks < 1) return null;
            return sprintf('%.2f', this.data[coin].averages['3h']['rate' + avg] * Math.pow(2, 32) / 600 / Math.pow(10, 18));
        }
    }, 'tsrate', function tsrate(coin, ts) {
        var o = this.data[coin].history['all'].find(function (h) {
            return h.timestamp === ts;
        });
        return o ? o.rate12h : null;
    })
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sprintf_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sprintf_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'blocks-height',
    data: function data() {
        return {
            prevh: {
                BTC: null,
                BCH: null
            }
        };
    },
    mounted: function mounted() {
        this.redraw();
    },

    computed: {
        height_diff_txt: function height_diff_txt() {
            var bh = this.data.BTC.averages.last.height;
            var ch = this.data.BCH.averages.last.height;

            if (bh > ch) {
                return 'BTC is currently ahead by ' + (bh - ch) + ' blocks.';
            } else {
                return 'BCH is currently ahead by ' + (ch - bh) + ' blocks.';
            }
        }
    },
    methods: {
        height: function height(obj, coin) {
            var other = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            var h = obj.height > 0 ? obj.height : null;

            if (h) {
                this.prevh[coin] = h;
                return h;
            }

            if (this.prevh[coin] > 481800) {
                return this.prevh[coin];
            }

            return null;
        },
        redraw: function redraw() {
            var _this = this;

            this.prevh.BTC = null;
            this.prevh.BCH = null;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'BTC',
                backgroundColor: this.btc_cbg,
                borderColor: this.btc_c,
                spanGaps: true,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return _this.height(obj, 'BTC');
                })
            });

            this.add_dataset({
                label: 'BCH',
                backgroundColor: this.bch_cbg,
                borderColor: this.bch_c,
                spanGaps: true,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return _this.height(obj, 'BCH', 'BTC');
                })
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Block chain height'
                            },
                            ticks: {
                                callback: function callback(value, index, values) {
                                    return value;
                                }
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-height', config, labels);
        }
    },
    destroy: function destroy() {
        this.chart.destroy();
    }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'blocks-inflation',
  data: function data() {
    return {
      previ: {
        BTC: null,
        BCH: null
      }
    };
  },
  mounted: function mounted() {
    this.redraw();
  },

  methods: {
    inflation_rate: function inflation_rate(obj) {

      var coins = this.supply(obj.height);

      var newcoins = coins + obj.blocks * this.subsidy(obj.height);
      var inflation = (newcoins - coins) / newcoins * 100;

      return this.sprintf('%.4f', inflation);
    },
    inflation_rate_fork: function inflation_rate_fork(coin, obj) {

      if (obj.height == 0) {
        return this.previ[coin];
      }

      var coins = this.supply(obj.height);
      var sincefork = coins - this.supply(478559);
      var prefork = coins - sincefork;

      var diff = (coins - prefork) / prefork * 100;

      this.previ[coin] = diff;

      return this.sprintf('%.4f', diff);
    },
    redraw: function redraw() {
      var _this = this;

      this.previ.BTC = null;
      this.previ.BCH = null;

      var labels = this.data.BTC.history['all'].map(function (obj) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
      });
      labels.pop();

      var btc = this.data.BTC.history['all'].map(function (obj) {
        return _this.inflation_rate_fork('BTC', obj);
      });
      btc.pop();
      var bch = this.data.BCH.history['all'].map(function (obj) {
        return _this.inflation_rate_fork('BCH', obj);
      });
      bch.pop();

      var btcr = this.data.BTC.history['all'].map(function (obj) {
        return _this.inflation_rate(obj);
      });
      btcr.pop();
      var bchr = this.data.BCH.history['all'].map(function (obj) {
        return _this.inflation_rate(obj);
      });
      bchr.pop();

      this.add_dataset({
        label: 'BTC total',
        backgroundColor: this.btc_cbg,
        borderColor: this.btc_c,
        data: btc,
        yAxisID: 'inflation'
      });
      this.add_dataset({
        label: 'BTC rate',
        backgroundColor: this.btc_cbg,
        borderColor: this.btc_c,
        data: btcr,
        borderDash: [3, 3],
        yAxisID: 'rate'
      });

      this.add_dataset({
        label: 'BCH total',
        backgroundColor: this.bch_cbg,
        borderColor: this.bch_c,
        data: bch,
        yAxisID: 'inflation'
      });

      this.add_dataset({
        label: 'BCH rate',
        backgroundColor: this.bch_cbg,
        borderColor: this.bch_c,
        data: bchr,
        borderDash: [3, 3],
        yAxisID: 'rate'
      });

      var config = {
        type: 'line',
        options: {
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Date/Time'
              }
            }],
            yAxes: [{
              display: true,
              id: 'inflation',
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'Total inflation'
              },
              ticks: {
                callback: function callback(value, index, values) {
                  return _this.sprintf('%.2f', value) + '%';
                }
              }
            }, {
              display: true,
              id: 'rate',
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'Inflation rate'
              },
              ticks: {
                callback: function callback(value, index, values) {
                  return _this.sprintf('%.3f', value) + '%';
                }
              }
            }]
          }
        }
      };

      this.draw('canvas-inflation', config, labels);
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'reward-opportunity',
    data: function data() {
        return {
            total: 0.0,
            zero: false
        };
    },

    computed: {
        time: function time() {
            return this.BTC.history['all'][1].timestamp - this.BTC.history['all'][0].timestamp;
        },
        lg: function lg() {
            return this.total > 0 ? 'gained' : 'lost';
        },
        total_cap: function total_cap() {
            if (this.zero) return 0;
            return this.total < 0 ? '0.00' : this.total;
        }
    },
    mounted: function mounted() {
        this.redraw();
    },

    methods: {
        redraw: function redraw() {
            var _this = this;

            this.total = 0.0;
            this.zero = false;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'BCH',
                backgroundColor: this.bch_cbg,
                borderColor: this.bch_c,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return _this.balance(obj);
                }),
                fill: true
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Opportunity cost (USD)'
                            },
                            ticks: {
                                callback: function callback(value, index, values) {
                                    return _this.money(value);
                                }
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-opportunity', config, labels);
        },
        balance: function balance(obj) {
            if (this.zero) return 0;
            var btc = this.find_ts('BTC', obj.timestamp);
            var bch = this.find_ts('BCH', obj.timestamp);

            if (!btc || !bch || btc.blocks < 1 || bch.blocks < 1) {
                return this.total;
            }

            var thr = btc.rate + bch.rate;
            var rpct = bch.rate / thr;

            var btc_speed = btc.rate / btc.avg_diff;
            var btc_speed_total = (btc.rate + bch.rate) / btc.avg_diff;
            var speed_diff = btc_speed_total - btc_speed;

            var new_reward = btc.reward_avg - (btc.reward_avg - this.subsidy(btc.height) * 100000000) * (3 * speed_diff);

            var btc_total = new_reward / 100000000 * (bch.blocks * (bch.avg_diff / btc.avg_diff)) * btc.price;
            var bch_total = bch.reward_avg / 100000000 * bch.blocks * bch.price;

            this.total += btc_total - bch_total;

            if (this.total < 0) {
                this.zero = true;
                this.total = 0;
            }

            return this.sprintf('%.2f', this.total);
        }
    }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sprintf_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sprintf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rdari-chart',
  mounted: function mounted() {
    this.redraw();
  },
  data: function data() {
    return {
      chart_height: '256px'
    };
  },

  methods: {
    rdari: function rdari(coin1, coin2, n) {
      var a = this.data[coin1].summary.dari_relative[n];
      var b = this.data[coin2].summary.dari_relative[n];

      if (!a || !b) return null;

      if (a > b) {
        return this.sprintf('%.3f', a / b);
      } else {
        return '1.00';
      }
    },
    redraw: function redraw() {
      var _this = this;

      var labels = this.data.BTC.summary.dari_relative.map(function (obj, n) {
        return n;
      });

      this.add_dataset({
        type: 'line',
        label: 'BTC',
        borderColor: this.btc_c,
        spanGaps: true,
        steppedLine: true,
        borderWidth: 1,
        data: this.data.BTC.summary.dari_relative.map(function (obj, n) {
          return _this.rdari('BTC', 'BCH', n);
        })
      }, function (d) {
        d.lineTension = 0;
      });

      this.add_dataset({
        type: 'line',
        label: 'BCH',
        borderColor: this.bch_c,
        spanGaps: true,
        steppedLine: true,
        borderWidth: 1,
        data: this.data.BCH.summary.dari_relative.map(function (obj, n) {
          return _this.rdari('BCH', 'BTC', n);
        })
      }, function (d) {
        d.lineTension = 0;
      });

      var config = {
        type: 'line',
        options: {
          legend: {
            display: true
          },
          title: {
            display: true,
            text: 'Relative miner reward for work done (DARI ratio, past week)'
          },
          scales: {
            xAxes: [{
              display: false
            }],
            yAxes: [{
              display: true,
              position: 'right',
              scaleLabel: {
                display: false,
                labelString: 'Relative DARI'
              },
              ticks: {
                callback: function callback(v) {
                  return _this.sprintf('%.2fx', v);
                }
              }
            }]
          }
        }
      };

      this.draw('canvas-rdari', config, labels);
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_humanize_duration__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_humanize_duration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_humanize_duration__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pow-retarget',
  mounted: function mounted() {
    this.redraw();
  },

  methods: {
    redraw: function redraw() {
      var _this = this;

      var labels = this.data.BTC.history['all'].map(function (obj) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
      });

      this.add_dataset({
        label: 'BTC',
        borderColor: this.btc_c,
        data: this.data.BTC.history['all'].map(function (obj) {
          return _this.estimate('BTC', obj);
        }),
        spanGaps: true
      });

      this.add_dataset({
        label: 'BCH',
        borderColor: this.bch_c,
        data: this.data.BCH.history['all'].map(function (obj) {
          return _this.estimate('BCH', obj);
        }),
        spanGaps: true
      });

      var config = {
        type: 'line',
        options: {
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Date/Time'
              }
            }],
            yAxes: [{
              display: true,
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'Days'
              },
              ticks: {
                callback: function callback(value, index, values) {
                  return _this.numeral('0,0', value);
                }
              }
            }]
          }
        }
      };

      this.draw('canvas-retarget', config, labels);
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'rewrite-chain',
    computed: {
        replace_chain: function replace_chain() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration({
                minutes: this.data.BCH.pow.split.work / this.data.BTC.pow.current.work_actual * 10
            }).humanize();
        }
    },
    mounted: function mounted() {
        this.redraw();
    },

    methods: {
        rate: function rate(ts) {
            var btc = this.data['BTC'].history['all'].find(function (h) {
                return h.timestamp === ts;
            });
            var bch = this.data['BCH'].history['all'].find(function (h) {
                return h.timestamp === ts;
            });

            if (!btc || !bch) {
                return null;
            }

            return btc.rate + bch.rate;
        },
        tsrate: function tsrate(coin, ts) {
            var o = this.data[coin].history['all'].find(function (h) {
                return h.timestamp === ts;
            });
            return o ? o.rate : null;
        },
        redraw: function redraw() {
            var _this = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            var rate = this.data['BTC'].pow.current.work_actual + this.data['BCH'].pow.current.work_actual;

            var attack = function attack(obj) {
                if (obj.blocks < 1) {
                    return null;
                }

                var rate = _this.rate(obj.timestamp);
                if (rate === null) {
                    return null;
                }

                return _this.sprintf('%.2f', obj.work / rate * 10 / 60 / 24);
            };

            this.add_dataset({
                label: 'BTC',
                borderColor: this.btc_c,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return attack(obj);
                })
            });

            this.add_dataset({
                label: 'BCH',
                borderColor: this.bch_c,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return attack(obj);
                })
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Days'
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-attack-full', config, labels);
        }
    }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'rewrite-fork',
    computed: {
        replace_chain: function replace_chain() {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration({
                minutes: this.data.BCH.pow.split.work / this.data.BTC.pow.current.work_actual * 10
            }).humanize();
        }
    },
    mounted: function mounted() {
        this.redraw();
    },

    methods: {
        redraw: function redraw() {
            var _this = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            var prework = 32729585000856628.00;

            var rate = this.data['BTC'].pow.current.work_actual + this.data['BCH'].pow.current.work_actual;
            var attack = function attack(obj, r) {
                if (obj.blocks < 1) return null;
                if (!r) return null;
                return _this.sprintf('%.2f', (obj.work - prework) / r * 10 / 60 / 24);
            };

            this.add_dataset({
                label: '5%',
                borderWidth: 1,
                borderColor: '#42cbf4',
                spanGaps: true,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return attack(obj, _this.rate(obj.timestamp) * 0.05);
                })
            });

            this.add_dataset({
                label: '10%',
                borderWidth: 1,
                borderColor: '#ad5eed',
                spanGaps: true,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return attack(obj, _this.rate(obj.timestamp) * 0.10);
                })
            });

            this.add_dataset({
                label: '25%',
                borderWidth: 1,
                borderColor: '#ff0000',
                spanGaps: true,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return attack(obj, _this.rate(obj.timestamp) * 0.25);
                })
            });

            this.add_dataset({
                label: 'BTC hashrate',
                borderWidth: 1,
                borderColor: this.btc_c,
                spanGaps: true,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return attack(obj, _this.tsrate('BTC', obj.timestamp));
                })
            });

            this.add_dataset({
                label: 'BCH hashrate',
                borderWidth: 1,
                borderColor: this.bch_c,
                spanGaps: true,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return attack(obj, _this.tsrate('BCH', obj.timestamp));
                })
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Days'
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-attack', config, labels);
        },
        replace_chain_rate: function replace_chain_rate(rate) {
            return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration({
                minutes: this.data.BCH.pow.split.work / this.global_rate(rate) * 10
            }).humanize();
        },
        global_rate: function global_rate(pct) {
            return (this.data['BTC'].pow.current.work_actual + this.data['BCH'].pow.current.work_actual) * pct;
        },
        rate: function rate(ts) {
            var btc = this.data['BTC'].history['all'].find(function (h) {
                return h.timestamp === ts;
            });
            var bch = this.data['BCH'].history['all'].find(function (h) {
                return h.timestamp === ts;
            });

            if (!btc || !bch) {
                return null;
            }

            return btc.rate + bch.rate;
        },
        tsrate: function tsrate(coin, ts) {
            var o = this.data[coin].history['all'].find(function (h) {
                return h.timestamp === ts;
            });
            return o ? o.rate : null;
        }
    }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pow-speed',
  mounted: function mounted() {
    this.redraw();
  },

  computed: {
    stats: function stats() {
      var _this = this;

      return {
        header: ['3h', '12h', '1d', '3d', '7d'],
        f: function f(coin, avg) {
          var spd = _this.speed(_this.data[coin].averages.last, 'rate' + avg);
          return spd + "%";
        },
        coins: [{
          coin: 'BTC',
          values: ['3h', '12h', '1d', '3d', '7d']
        }, {
          coin: 'BCH',
          values: ['3h', '12h', '1d', '3d', '7d']
        }]
      };
    }
  },
  methods: {
    speed: function speed(obj) {
      var rate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (obj.blocks < 1) return '0.00';

      if (rate !== null) {
        var spd = obj[rate] / obj.avg_diff - 1;
        spd *= 100;

        var formatted = this.sprintf('%.2f', spd);
        return spd > 0 ? '+' + formatted : formatted;
      }

      return null;
    },
    redraw: function redraw() {
      var _this2 = this;

      var labels = this.data.BTC.history['all'].map(function (obj) {
        return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
      });

      this.add_dataset({
        label: 'BTC',
        borderColor: this.btc_c,
        data: this.data.BTC.history['all'].map(function (obj) {
          return _this2.speed(obj, 'rate3h');
        })
      });

      this.add_dataset({
        label: 'BCH',
        borderColor: this.bch_c,
        data: this.data.BCH.history['all'].map(function (obj) {
          return _this2.speed(obj, 'rate3h');
        })
      });

      var config = {
        type: 'line',
        options: {
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Date/Time'
              }
            }],
            yAxes: [{
              display: true,
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'Relative speed'
              },
              ticks: {
                callback: function callback(val) {
                  return val + "%";
                },

                min: -100
              }
            }]
          }
        }
      };

      this.draw('canvas-speed', config, labels);
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'block-txfee-sat',
    mounted: function mounted() {
        this.redraw();
    },

    computed: {
        stats: function stats() {
            var _this = this;

            return {
                header: ['3h', '6h', '12h', '1d', '7d'],
                f: function f(coin, avg) {
                    return _this.txfee(_this.data[coin].averages[avg]);
                },
                coins: [{
                    coin: 'BTC',
                    values: ['3h', '6h', '12h', '1d', '7d']
                }, {
                    coin: 'BCH',
                    values: ['3h', '6h', '12h', '1d', '7d']
                }]
            };
        }
    },
    methods: {
        txfee: function txfee(obj) {
            if (obj.blocks < 1 || obj.price < 1) return null;

            return this.sprintf('%.2f', (obj.reward_avg - this.subsidy(obj.height) * 100000000) / obj.size);
        },
        redraw: function redraw() {
            var _this2 = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'BTC',
                borderColor: this.btc_c,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return _this2.txfee(obj);
                })
            });

            this.add_dataset({
                label: 'BCH',
                borderColor: this.bch_c,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return _this2.txfee(obj);
                })
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Tx fee/byte (satoshis)'
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-txfee-sat', config, labels);
        }
    }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'block-txs',
    mounted: function mounted() {
        this.redraw();
    },

    computed: {
        stats: function stats() {
            var _this = this;

            return {
                header: ['3h', '6h', '12h', '1d', '7d'],
                f: function f(coin, avg) {
                    return _this.txs(_this.data[coin].averages[avg]);
                },
                coins: [{
                    coin: 'BTC',
                    values: ['3h', '6h', '12h', '1d', '7d']
                }, {
                    coin: 'BCH',
                    values: ['3h', '6h', '12h', '1d', '7d']
                }]
            };
        }
    },
    methods: {
        txs: function txs(obj) {
            if (obj.blocks < 1) return null;
            return obj.blocks > 0 ? this.sprintf('%.2f', obj.txs) : null;
        },
        redraw: function redraw() {
            var _this2 = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'BTC',
                borderColor: this.btc_c,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return _this2.txs(obj);
                })
            });

            this.add_dataset({
                label: 'BCH',
                borderColor: this.bch_c,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return _this2.txs(obj);
                })
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Transactions'
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-txs', config, labels);
        }
    }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_written_number__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_written_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_written_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_big_integer__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_big_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_big_integer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pow-work',
    mounted: function mounted() {
        this.redraw();
    },

    computed: {
        hashes: function hashes() {
            return __WEBPACK_IMPORTED_MODULE_4_big_integer___default()(this.data.BTC.averages.last.work).multiply(Math.pow(2, 32)).toString();
        }
    },
    methods: {
        work: function work(obj) {
            if (obj.work === 0) return null;
            return this.sprintf('%.2f', obj.work / 1000000000000);
        },
        redraw: function redraw() {
            var _this = this;

            var labels = this.data.BTC.history['all'].map(function (obj) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(obj.timestamp).format("MMM, DD HH:mm");
            });

            this.add_dataset({
                label: 'BTC',
                borderColor: this.btc_c,
                data: this.data.BTC.history['all'].map(function (obj) {
                    return _this.work(obj);
                }),
                spanGaps: true
            });

            this.add_dataset({
                label: 'BCH',
                borderColor: this.bch_c,
                data: this.data.BCH.history['all'].map(function (obj) {
                    return _this.work(obj);
                }),
                spanGaps: true
            });

            var config = {
                type: 'line',
                options: {
                    scales: {
                        xAxes: [{
                            display: true,
                            scaleLabel: {
                                display: true,
                                labelString: 'Date/Time'
                            }
                        }],
                        yAxes: [{
                            display: true,
                            position: 'right',
                            scaleLabel: {
                                display: true,
                                labelString: 'Total work (trillions)'
                            },
                            ticks: {
                                callback: function callback(value, index, values) {
                                    return _this.numeral('0,0', value);
                                }
                            }
                        }]
                    }
                }
            };

            this.draw('canvas-work', config, labels);
        }
    }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'contact'
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_dari_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_dari_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__charts_dari_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_duration__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_duration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_humanize_duration__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    dari: __WEBPACK_IMPORTED_MODULE_0__charts_dari_vue___default.a
  },
  data: function data() {
    return {
      chart: null
    };
  },

  computed: {
    first_retarget: function first_retarget() {
      return 'BTC';

      var at = this.estimate('BTC', this.data['BTC'].averages.last, true);
      var bt = this.estimate('BCH', this.data['BCH'].averages.last, true);

      if (!at || !bt) return null;

      return at < bt ? 'BTC' : 'BCH';
    },
    time_retarget: function time_retarget() {
      var coin = this.first_retarget;
      if (coin === null) return null;
      var mins = this.estimate(coin, this.data[coin].averages.last, true);
      return __WEBPACK_IMPORTED_MODULE_1_humanize_duration___default()(mins * 60 * 1000, { largest: 2 });
    },
    left: function left() {
      var l = this.first_retarget;
      if (l === null) return null;
      var h = this.data[l].averages.last.height;
      return 2016 - h % 2016;
    },
    empty_any: function empty_any() {
      return false; //this.data.BTC.averages.last.txs === 1 || this.data.BCH.averages.last.txs === 1
    },
    poll: function poll() {
      return this.$store.getters['poll'];
    }
  },
  methods: {
    dari_period: function dari_period(coin, coin2, p) {
      var strong = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var a = this.data[coin].averages[p];
      var b = this.data[coin2].averages[p];
      if (a.blocks < 1 || b.blocks < 1) return '-';

      var space = '______';

      var pct = this.data[coin].averages[p].dari / this.data[coin2].averages[p].dari;
      if (pct < 1) pct = 1;

      var res = sprintf('%.2f', pct);

      if (strong) {
        return '<span class="' + (pct > 1 ? 'advantage' : 'disadvantage_x') + '">' + (pct > 0 ? res + 'x' : space) + '</span>';
      }

      return '<span class="' + (pct > 1 ? 'advantage_sm' : 'disadvantage_sm_x') + '">' + (pct > 0 ? res + 'x' : space) + '</span>';
    },
    next_dari_coin: function next_dari_coin(coin, coin2) {
      var at = this.estimate(coin, this.data[coin].averages.last, true);
      var bt = this.estimate(coin2, this.data[coin2].averages.last, true);

      var a = this.data[coin].averages.last.dari;
      var b = this.data[coin2].averages.last.dari;

      var tbd = '<span class="mini">(<span class="disadvantage_sm_x">T.B.D.</span>)</span>';

      if (!at || !bt || !a || !b) {
        return tbd;
      }

      if (at < bt) {
        a = this.data[coin].averages.last.dari;
        a = a / this.next_pct(coin, true);
      } else {
        b = this.data[coin2].averages.last.dari;
        b = b / this.next_pct(coin2, true);
      }

      var pct = a / b;
      if (pct < 1) pct = 1;

      var res = this.sprintf('%.2f', pct);
      var space = '______';
      return '<span class="mini">(<span class="' + (pct > 1 ? 'advantage_sm' : 'disadvantage_sm_x') + '">' + (pct > 0 ? res + 'x' : space) + '</span>)</span>';
    },
    next_dari: function next_dari(coin, obj) {
      var pct = this.next_pct(coin, true);
      return this.sprintf('%.3f', obj.dari * pct);
    },
    estimate: function estimate(coin, obj) {
      var m = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


      if (coin === 'BCH') return 99999;

      var prev = this.data[coin].retargets.slice(-1)[0];
      var last = obj;

      if (prev === undefined) prev = this.preforktarget;

      var mod = last.height % 2016;
      if (mod === 0 || mod === 1) return null;

      var left = 2016 - mod;
      var blkhr = obj.rate12h / obj.avg_diff * 6;

      var hr = left / blkhr;

      var days = hr / 24;
      var mins = hr * 60;

      return m === false ? this.sprintf('%.2f', days) : mins;
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'block-txfee-sat',
    props: {
        stats: Object
    },
    data: function data() {
        return {};
    }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_hashrate_dari_vue__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_hashrate_dari_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__charts_hashrate_dari_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'hashdari',
    data: function data() {
        return {};
    },

    components: {
        'hashrate-dari': __WEBPACK_IMPORTED_MODULE_2__charts_hashrate_dari_vue___default.a
    }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pow'
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'inflation'
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'security'
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_dari_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_dari_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__charts_dari_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_duration__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_duration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_humanize_duration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_feemarket_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_feemarket_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__charts_feemarket_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__charts_rdari_vue__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__charts_rdari_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__charts_rdari_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'summary',
  components: {
    feemarket: __WEBPACK_IMPORTED_MODULE_3__charts_feemarket_vue___default.a,
    rdari: __WEBPACK_IMPORTED_MODULE_4__charts_rdari_vue___default.a
  },
  data: function data() {
    return {
      chart: null,
      rewardperiod: 'day',
      showstats: {
        'dari': true,
        'hashrate': true,
        'blockrate': true,
        'txs': true,
        'txfee': true,
        'reward': true,
        'blocksize': true,
        'retarget': true,
        'halvening': true
      },
      eri: null
    };
  },
  mounted: function mounted() {
    if (localStorage.getItem('showstats.enabled') === '1') {
      var show = localStorage.getItem('showstats');
      this.showstats = JSON.parse(show);
    }
    var rp = localStorage.getItem('rewardperiod');
    if (rp) this.rewardperiod = rp;
    this.startExchangerates();
  },
  destroyed: function destroyed() {
    clearInterval(this.eri);
  },

  computed: {
    coins: function coins() {
      return ['BTC', 'BCH'];
    },
    visible: function visible() {
      return this.$store.getters['visible'];
    }
  },
  watch: {
    rewardperiod: function rewardperiod(n, o) {
      localStorage.setItem('rewardperiod', n);
    },
    visible: function visible(n, o) {
      if (n === true) {
        this.startExchangerates();
      } else {
        clearInterval(this.eri);
      }
    }
  },
  methods: {
    startExchangerates: function startExchangerates() {
      this.eri = setInterval(this.exchangerates, 10000);
    },
    exchangerates: function exchangerates() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("/api/" + 'exchangerate').then(function (resp) {
        _this.data.BTC.summary.price.now = resp.data.btc;
        _this.data.BCH.summary.price.now = resp.data.bch;
      }).catch(function (err) {
        console.log(err);
      });
    },
    sum: function sum(coin) {
      return this.data[coin].summary;
    },
    toggle: function toggle(stat, e) {
      this.showstats[stat] = !this.showstats[stat];
      localStorage.setItem('showstats', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.showstats));
      localStorage.setItem('showstats.enabled', '1');
    },
    hashrate_rel: function hashrate_rel(coin, d) {
      var s = this.sum(coin).hashrate[d];
      var o = this.sum(this.coino(coin)).hashrate[d];
      var t = s + o;

      return this.sprintf('%.2f%%', s / t * 100);
    },
    dari_rel: function dari_rel(coin, d) {
      var a = this.data[coin].summary.dari[d];
      var b = this.data[this.coino(coin)].summary.dari[d];

      if (a > b) {
        return '<span class="hidari">' + this.sprintf('%.2fx', a / b) + '</span>';
      } else {
        return '<span class="lodari">1.00x</span>';
      }
    },
    fee_normalized: function fee_normalized(coin) {
      var p = 5000 / this.sum(coin).price.now;
      return this.money(this.sum(coin).tx_fees.usd_kb * p);
    },
    halvening_reward: function halvening_reward(coin) {

      var n = this.sum(coin).halvening.reward_new;
      var o = this.sum(coin).halvening.reward;

      var change = (n / o - 1) * 100;
      var formatted = this.sprintf('%.2f%%', change);
      var reward = this.money(n * this.sum(coin).price.now, false);

      return reward + ' (' + formatted + ')';
    },
    halvening_fees: function halvening_fees(coin) {
      var subsidy = this.subsidy(this.data[coin].averages.last.height);
      var n = (this.sum(coin).halvening.reward_new - subsidy / 2) / this.sum(coin).halvening.reward_new;
      var o = (this.sum(coin).halvening.reward - subsidy) / this.sum(coin).halvening.reward;
      var pct = this.sprintf('%.2f%%', n * 100);

      return '' + pct;
    },
    price_change: function price_change(coin) {
      var icon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var n = this.sum(coin).price.now;
      var o = this.sum(coin).price.day_1;

      var change = (n / o - 1) * 100;

      var formatted = this.sprintf('%.2f%%', change);
      formatted = change > 0 ? '+' + formatted : formatted;

      if (change > 0) {
        return icon ? '<i class="fa fa-chevron-up green"></i>' : '<span class="green">' + formatted + '</span>';
      } else {
        return icon ? '<i class="fa fa-chevron-down red"></i>' : '<span class="red">' + formatted + '</span>';
      }
    },
    price_ratio: function price_ratio() {
      var icon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var n = this.sum('BCH').price.now / this.sum('BTC').price.now;
      var o = this.sum('BCH').price.day_1 / this.sum('BTC').price.day_1;

      var change = (n / o - 1) * 100;

      var formatted = this.sprintf('%.2f%%', change);
      formatted = change > 0 ? '+' + formatted : formatted;

      if (change > 0) {
        return icon ? '<i class="fa fa-chevron-up green"></i>' : '<span class="green">' + formatted + '</span>';
      } else {
        return icon ? '<i class="fa fa-chevron-down red"></i>' : '<span class="red">' + formatted + '</span>';
      }
    },
    rp: function rp(coin) {
      // active reward period
      return this.sum(coin).reward[this.rewardperiod];
    },
    rpb: function rpb(coin) {
      // active reward period blocks
      return this.rp(coin).blocks;
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'tx'
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notification__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_common_js__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_chart_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_misc_stat_table_vue__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_misc_stat_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_misc_stat_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_chart_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_chart_js__);
__webpack_require__(7);
__webpack_require__(283);
__webpack_require__(282);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_5__mixins_common_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_6__mixins_chart_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('stat-table', __WEBPACK_IMPORTED_MODULE_7__components_misc_stat_table_vue___default.a);



__WEBPACK_IMPORTED_MODULE_8_chart_js___default.a.defaults.global.responsive = true;
__WEBPACK_IMPORTED_MODULE_8_chart_js___default.a.defaults.global.maintainAspectRatio = false;
__WEBPACK_IMPORTED_MODULE_8_chart_js___default.a.defaults.global.animation = false;
__WEBPACK_IMPORTED_MODULE_8_chart_js___default.a.defaults.global.elements.line.backgroundColor = "rgba(0,0,0,0)";
__WEBPACK_IMPORTED_MODULE_8_chart_js___default.a.defaults.global.elements.line.fill = false;
__WEBPACK_IMPORTED_MODULE_8_chart_js___default.a.defaults.global.elements.line.borderWidth = 1;
__WEBPACK_IMPORTED_MODULE_8_chart_js___default.a.defaults.global.elements.point.radius = 0;
//Chart.defaults.global.tooltips = { "mode": false, "intersect": false }
__WEBPACK_IMPORTED_MODULE_8_chart_js___default.a.defaults.global.title.display = false;
__WEBPACK_IMPORTED_MODULE_8_chart_js___default.a.defaults.global.title.display = false;
__WEBPACK_IMPORTED_MODULE_8_chart_js___default.a.defaults.global.defaultFontColor = '#000';
__WEBPACK_IMPORTED_MODULE_8_chart_js___default.a.defaults.global.defaultFontSize = 12;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 34,
	"./af.js": 34,
	"./ar": 41,
	"./ar-dz": 35,
	"./ar-dz.js": 35,
	"./ar-kw": 36,
	"./ar-kw.js": 36,
	"./ar-ly": 37,
	"./ar-ly.js": 37,
	"./ar-ma": 38,
	"./ar-ma.js": 38,
	"./ar-sa": 39,
	"./ar-sa.js": 39,
	"./ar-tn": 40,
	"./ar-tn.js": 40,
	"./ar.js": 41,
	"./az": 42,
	"./az.js": 42,
	"./be": 43,
	"./be.js": 43,
	"./bg": 44,
	"./bg.js": 44,
	"./bn": 45,
	"./bn.js": 45,
	"./bo": 46,
	"./bo.js": 46,
	"./br": 47,
	"./br.js": 47,
	"./bs": 48,
	"./bs.js": 48,
	"./ca": 49,
	"./ca.js": 49,
	"./cs": 50,
	"./cs.js": 50,
	"./cv": 51,
	"./cv.js": 51,
	"./cy": 52,
	"./cy.js": 52,
	"./da": 53,
	"./da.js": 53,
	"./de": 56,
	"./de-at": 54,
	"./de-at.js": 54,
	"./de-ch": 55,
	"./de-ch.js": 55,
	"./de.js": 56,
	"./dv": 57,
	"./dv.js": 57,
	"./el": 58,
	"./el.js": 58,
	"./en-au": 59,
	"./en-au.js": 59,
	"./en-ca": 60,
	"./en-ca.js": 60,
	"./en-gb": 61,
	"./en-gb.js": 61,
	"./en-ie": 62,
	"./en-ie.js": 62,
	"./en-nz": 63,
	"./en-nz.js": 63,
	"./eo": 64,
	"./eo.js": 64,
	"./es": 66,
	"./es-do": 65,
	"./es-do.js": 65,
	"./es.js": 66,
	"./et": 67,
	"./et.js": 67,
	"./eu": 68,
	"./eu.js": 68,
	"./fa": 69,
	"./fa.js": 69,
	"./fi": 70,
	"./fi.js": 70,
	"./fo": 71,
	"./fo.js": 71,
	"./fr": 74,
	"./fr-ca": 72,
	"./fr-ca.js": 72,
	"./fr-ch": 73,
	"./fr-ch.js": 73,
	"./fr.js": 74,
	"./fy": 75,
	"./fy.js": 75,
	"./gd": 76,
	"./gd.js": 76,
	"./gl": 77,
	"./gl.js": 77,
	"./gom-latn": 78,
	"./gom-latn.js": 78,
	"./he": 79,
	"./he.js": 79,
	"./hi": 80,
	"./hi.js": 80,
	"./hr": 81,
	"./hr.js": 81,
	"./hu": 82,
	"./hu.js": 82,
	"./hy-am": 83,
	"./hy-am.js": 83,
	"./id": 84,
	"./id.js": 84,
	"./is": 85,
	"./is.js": 85,
	"./it": 86,
	"./it.js": 86,
	"./ja": 87,
	"./ja.js": 87,
	"./jv": 88,
	"./jv.js": 88,
	"./ka": 89,
	"./ka.js": 89,
	"./kk": 90,
	"./kk.js": 90,
	"./km": 91,
	"./km.js": 91,
	"./kn": 92,
	"./kn.js": 92,
	"./ko": 93,
	"./ko.js": 93,
	"./ky": 94,
	"./ky.js": 94,
	"./lb": 95,
	"./lb.js": 95,
	"./lo": 96,
	"./lo.js": 96,
	"./lt": 97,
	"./lt.js": 97,
	"./lv": 98,
	"./lv.js": 98,
	"./me": 99,
	"./me.js": 99,
	"./mi": 100,
	"./mi.js": 100,
	"./mk": 101,
	"./mk.js": 101,
	"./ml": 102,
	"./ml.js": 102,
	"./mr": 103,
	"./mr.js": 103,
	"./ms": 105,
	"./ms-my": 104,
	"./ms-my.js": 104,
	"./ms.js": 105,
	"./my": 106,
	"./my.js": 106,
	"./nb": 107,
	"./nb.js": 107,
	"./ne": 108,
	"./ne.js": 108,
	"./nl": 110,
	"./nl-be": 109,
	"./nl-be.js": 109,
	"./nl.js": 110,
	"./nn": 111,
	"./nn.js": 111,
	"./pa-in": 112,
	"./pa-in.js": 112,
	"./pl": 113,
	"./pl.js": 113,
	"./pt": 115,
	"./pt-br": 114,
	"./pt-br.js": 114,
	"./pt.js": 115,
	"./ro": 116,
	"./ro.js": 116,
	"./ru": 117,
	"./ru.js": 117,
	"./sd": 118,
	"./sd.js": 118,
	"./se": 119,
	"./se.js": 119,
	"./si": 120,
	"./si.js": 120,
	"./sk": 121,
	"./sk.js": 121,
	"./sl": 122,
	"./sl.js": 122,
	"./sq": 123,
	"./sq.js": 123,
	"./sr": 125,
	"./sr-cyrl": 124,
	"./sr-cyrl.js": 124,
	"./sr.js": 125,
	"./ss": 126,
	"./ss.js": 126,
	"./sv": 127,
	"./sv.js": 127,
	"./sw": 128,
	"./sw.js": 128,
	"./ta": 129,
	"./ta.js": 129,
	"./te": 130,
	"./te.js": 130,
	"./tet": 131,
	"./tet.js": 131,
	"./th": 132,
	"./th.js": 132,
	"./tl-ph": 133,
	"./tl-ph.js": 133,
	"./tlh": 134,
	"./tlh.js": 134,
	"./tr": 135,
	"./tr.js": 135,
	"./tzl": 136,
	"./tzl.js": 136,
	"./tzm": 138,
	"./tzm-latn": 137,
	"./tzm-latn.js": 137,
	"./tzm.js": 138,
	"./uk": 139,
	"./uk.js": 139,
	"./ur": 140,
	"./ur.js": 140,
	"./uz": 142,
	"./uz-latn": 141,
	"./uz-latn.js": 141,
	"./uz.js": 142,
	"./vi": 143,
	"./vi.js": 143,
	"./x-pseudo": 144,
	"./x-pseudo.js": 144,
	"./yo": 145,
	"./yo.js": 145,
	"./zh-cn": 146,
	"./zh-cn.js": 146,
	"./zh-hk": 147,
	"./zh-hk.js": 147,
	"./zh-tw": 148,
	"./zh-tw.js": 148
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 360;

/***/ }),
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b06871f281fee6b241d60582ae9369b9.ttf";

/***/ }),
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 158,
	"./af.js": 158,
	"./ar": 165,
	"./ar-dz": 159,
	"./ar-dz.js": 159,
	"./ar-kw": 160,
	"./ar-kw.js": 160,
	"./ar-ly": 161,
	"./ar-ly.js": 161,
	"./ar-ma": 162,
	"./ar-ma.js": 162,
	"./ar-sa": 163,
	"./ar-sa.js": 163,
	"./ar-tn": 164,
	"./ar-tn.js": 164,
	"./ar.js": 165,
	"./az": 166,
	"./az.js": 166,
	"./be": 167,
	"./be.js": 167,
	"./bg": 168,
	"./bg.js": 168,
	"./bm": 169,
	"./bm.js": 169,
	"./bn": 170,
	"./bn.js": 170,
	"./bo": 171,
	"./bo.js": 171,
	"./br": 172,
	"./br.js": 172,
	"./bs": 173,
	"./bs.js": 173,
	"./ca": 174,
	"./ca.js": 174,
	"./cs": 175,
	"./cs.js": 175,
	"./cv": 176,
	"./cv.js": 176,
	"./cy": 177,
	"./cy.js": 177,
	"./da": 178,
	"./da.js": 178,
	"./de": 181,
	"./de-at": 179,
	"./de-at.js": 179,
	"./de-ch": 180,
	"./de-ch.js": 180,
	"./de.js": 181,
	"./dv": 182,
	"./dv.js": 182,
	"./el": 183,
	"./el.js": 183,
	"./en-au": 184,
	"./en-au.js": 184,
	"./en-ca": 185,
	"./en-ca.js": 185,
	"./en-gb": 186,
	"./en-gb.js": 186,
	"./en-ie": 187,
	"./en-ie.js": 187,
	"./en-nz": 188,
	"./en-nz.js": 188,
	"./eo": 189,
	"./eo.js": 189,
	"./es": 192,
	"./es-do": 190,
	"./es-do.js": 190,
	"./es-us": 191,
	"./es-us.js": 191,
	"./es.js": 192,
	"./et": 193,
	"./et.js": 193,
	"./eu": 194,
	"./eu.js": 194,
	"./fa": 195,
	"./fa.js": 195,
	"./fi": 196,
	"./fi.js": 196,
	"./fo": 197,
	"./fo.js": 197,
	"./fr": 200,
	"./fr-ca": 198,
	"./fr-ca.js": 198,
	"./fr-ch": 199,
	"./fr-ch.js": 199,
	"./fr.js": 200,
	"./fy": 201,
	"./fy.js": 201,
	"./gd": 202,
	"./gd.js": 202,
	"./gl": 203,
	"./gl.js": 203,
	"./gom-latn": 204,
	"./gom-latn.js": 204,
	"./gu": 205,
	"./gu.js": 205,
	"./he": 206,
	"./he.js": 206,
	"./hi": 207,
	"./hi.js": 207,
	"./hr": 208,
	"./hr.js": 208,
	"./hu": 209,
	"./hu.js": 209,
	"./hy-am": 210,
	"./hy-am.js": 210,
	"./id": 211,
	"./id.js": 211,
	"./is": 212,
	"./is.js": 212,
	"./it": 213,
	"./it.js": 213,
	"./ja": 214,
	"./ja.js": 214,
	"./jv": 215,
	"./jv.js": 215,
	"./ka": 216,
	"./ka.js": 216,
	"./kk": 217,
	"./kk.js": 217,
	"./km": 218,
	"./km.js": 218,
	"./kn": 219,
	"./kn.js": 219,
	"./ko": 220,
	"./ko.js": 220,
	"./ky": 221,
	"./ky.js": 221,
	"./lb": 222,
	"./lb.js": 222,
	"./lo": 223,
	"./lo.js": 223,
	"./lt": 224,
	"./lt.js": 224,
	"./lv": 225,
	"./lv.js": 225,
	"./me": 226,
	"./me.js": 226,
	"./mi": 227,
	"./mi.js": 227,
	"./mk": 228,
	"./mk.js": 228,
	"./ml": 229,
	"./ml.js": 229,
	"./mr": 230,
	"./mr.js": 230,
	"./ms": 232,
	"./ms-my": 231,
	"./ms-my.js": 231,
	"./ms.js": 232,
	"./my": 233,
	"./my.js": 233,
	"./nb": 234,
	"./nb.js": 234,
	"./ne": 235,
	"./ne.js": 235,
	"./nl": 237,
	"./nl-be": 236,
	"./nl-be.js": 236,
	"./nl.js": 237,
	"./nn": 238,
	"./nn.js": 238,
	"./pa-in": 239,
	"./pa-in.js": 239,
	"./pl": 240,
	"./pl.js": 240,
	"./pt": 242,
	"./pt-br": 241,
	"./pt-br.js": 241,
	"./pt.js": 242,
	"./ro": 243,
	"./ro.js": 243,
	"./ru": 244,
	"./ru.js": 244,
	"./sd": 245,
	"./sd.js": 245,
	"./se": 246,
	"./se.js": 246,
	"./si": 247,
	"./si.js": 247,
	"./sk": 248,
	"./sk.js": 248,
	"./sl": 249,
	"./sl.js": 249,
	"./sq": 250,
	"./sq.js": 250,
	"./sr": 252,
	"./sr-cyrl": 251,
	"./sr-cyrl.js": 251,
	"./sr.js": 252,
	"./ss": 253,
	"./ss.js": 253,
	"./sv": 254,
	"./sv.js": 254,
	"./sw": 255,
	"./sw.js": 255,
	"./ta": 256,
	"./ta.js": 256,
	"./te": 257,
	"./te.js": 257,
	"./tet": 258,
	"./tet.js": 258,
	"./th": 259,
	"./th.js": 259,
	"./tl-ph": 260,
	"./tl-ph.js": 260,
	"./tlh": 261,
	"./tlh.js": 261,
	"./tr": 262,
	"./tr.js": 262,
	"./tzl": 263,
	"./tzl.js": 263,
	"./tzm": 265,
	"./tzm-latn": 264,
	"./tzm-latn.js": 264,
	"./tzm.js": 265,
	"./uk": 266,
	"./uk.js": 266,
	"./ur": 267,
	"./ur.js": 267,
	"./uz": 269,
	"./uz-latn": 268,
	"./uz-latn.js": 268,
	"./uz.js": 269,
	"./vi": 270,
	"./vi.js": 270,
	"./x-pseudo": 271,
	"./x-pseudo.js": 271,
	"./yo": 272,
	"./yo.js": 272,
	"./zh-cn": 273,
	"./zh-cn.js": 273,
	"./zh-hk": 274,
	"./zh-hk.js": 274,
	"./zh-tw": 275,
	"./zh-tw.js": 275
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 484;

/***/ }),
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI5MTJlYzY2ZDc1NzJmZjgyMTc0OTMxOTM5NjQ3MGJkZS5zdmciOw=="

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "af7ae505a9eed503f8b8e6982036873e.woff2";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fee66e712a8a08eef5805a46892932ad.woff";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(553),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(558),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(442)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(531),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-203a0eae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(538),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(447)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(560),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(444)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(533),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(540),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(548),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(450)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(466)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(555),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(443)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(532),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(454)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(543),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(557),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(439)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(528),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(534),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2fc3081c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(550),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(453)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(542),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(551),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(455)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(544),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a584ab9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(440)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(529),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c25035b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(463)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(552),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-75457398",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(562),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(559),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(446)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(535),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(438)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(527),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(460)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(549),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-690046db",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(556),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(458)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(554),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(452)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(541),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(561),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(441)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(530),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(475)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(564),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Total work done, or in other words, the sum of all block difficulties.\n        ")]), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n            Numbers are in trillions (1,000,000,000,000x).\n        ")]), _vm._v(" "), _c('small', [_vm._v("\n            Just for fun, the approximate total number of SHA256 hashes needed to produce the work: " + _vm._s(_vm.hashes) + ".\n            "), _c('br'), _vm._v("\n            Protip: memorize this number to impress your friends and family, they love to hear about it. No joke! ;)            \n        ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-work"
    }
  })])
}]}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("BTC")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BTC', '3h')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BTC', '12h')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BTC', '1d')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BTC', '3d')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BTC', '7d')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BCH")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BCH', '3h')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BCH', '12h')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BCH', '1d')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BCH', '3d')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BCH', '7d')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Absolute hashrate in exahashes per second ("), _c('u', [_vm._v("12h averages")]), _vm._v(").\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-hashrateabs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Coin")]), _vm._v(" "), _c('th', [_vm._v("3h")]), _vm._v(" "), _c('th', [_vm._v("12h")]), _vm._v(" "), _c('th', [_vm._v("1d")]), _vm._v(" "), _c('th', [_vm._v("3d")]), _vm._v(" "), _c('th', [_vm._v("7d")])])])
}]}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Proof of work equivalent days to rewrite the complete BTC or BCH chain with 100% of available hashrate. Basically the same idea as the \"fork rewrite\" chart only for the entire blockchain.\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-attack-full"
    }
  })])])
}]}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col col-xl-7 col-lg-8 col-md-10 col-sm-12"
  }, [_c('table', {
    staticClass: "table table-sm table-summary"
  }, [_c('tbody', [_vm._m(0, false, false), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Now")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n              " + _vm._s(_vm.money(_vm.sum(coin).price.now, false)) + "\n              ("), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.price_change(coin))
      }
    }), _vm._v(")\n            ")])
  }), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.sprintf('%.3f', _vm.sum('BCH').price.now / _vm.sum('BTC').price.now)) + "\n              ("), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.price_ratio(false))
    }
  }), _vm._v(")\n            ")])], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              -1d\n            ")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n              " + _vm._s(_vm.money(_vm.sum(coin).price.day_1, false)) + "\n            ")])
  }), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.sprintf('%.3f', _vm.sum('BCH').price.day_1 / _vm.sum('BTC').price.day_1)) + "\n            ")])], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              -7d\n            ")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n              " + _vm._s(_vm.money(_vm.sum(coin).price.day_7, false)) + "\n            ")])
  }), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.sprintf('%.3f', _vm.sum('BCH').price.day_7 / _vm.sum('BTC').price.day_7)) + "\n            ")])], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              -30d\n            ")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n              " + _vm._s(_vm.money(_vm.sum(coin).price.day_30, false)) + "\n            ")])
  }), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.sprintf('%.3f', _vm.sum('BCH').price.day_30 / _vm.sum('BTC').price.day_30)) + "\n            ")])], 2)])])])])]), _vm._v(" "), _c('rdari'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col col-xl-7 col-lg-8 col-md-10"
  }, [_c('table', {
    staticClass: "table table-sm table-summary"
  }, [_c('tbody', [_vm._m(1, false, false), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('dari')
      }
    }
  }, [(_vm.showstats.dari) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.dari) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                DARI ratio\n                "), _c('small', [_vm._v("(period averages)")])]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'reward.dari'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.dari) ? [_c('tr', [_c('td', [_vm._v("Now*")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_c('strong', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.dari_rel(coin, 'blk_3'))
      }
    })])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6 hour")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.dari_rel(coin, 'hour_6'))
      }
    })])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.dari_rel(coin, 'day_1'))
      }
    })])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("7 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.dari_rel(coin, 'day_7'))
      }
    })])
  })], 2), _vm._v(" "), _vm._m(2, false, false)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('hashrate')
      }
    }
  }, [(_vm.showstats.hashrate) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.hashrate) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Relative hashrate\n                "), _c('small', [_vm._v("(period averages)")])]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'pow.hashrate'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.hashrate) ? [_c('tr', [_c('td', [_vm._v("6 hours")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.hashrate_rel(coin, 'hour_6')) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.hashrate_rel(coin, 'day_1')) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("7 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.hashrate_rel(coin, 'day_7')) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("30 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.hashrate_rel(coin, 'day_30')) + "\n              ")])
  })], 2)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('blockrate')
      }
    }
  }, [(_vm.showstats.blockrate) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.blockrate) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Blocks found\n                "), _c('small', [_vm._v("(period sum/rate)")])]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'blocks.time'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.blockrate) ? [_c('tr', [_c('td', [_vm._v("Last hour")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.sum(coin).blocks.hour_1) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6 hours")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.sprintf('%.0f', _vm.sum(coin).blocks.hour_6)) + " (" + _vm._s(_vm.sprintf('%.2f', _vm.sum(coin).blocks.per_hour.hour_6)) + "/hr)\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("24 hours")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.sprintf('%.0f', _vm.sum(coin).blocks.day_1)) + " (" + _vm._s(_vm.sprintf('%.2f', _vm.sum(coin).blocks.per_hour.day_1)) + "/hr)\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2 weeks")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.sprintf('%.0f', _vm.sum(coin).blocks.day_14)) + " (" + _vm._s(_vm.sprintf('%.2f', _vm.sum(coin).blocks.per_hour.day_14)) + "/hr)\n              ")])
  })], 2)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('txs')
      }
    }
  }, [(_vm.showstats.txs) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.txs) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Confirmed transactions\n                "), _c('small', [_vm._v("(24h averages)")])]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'tx.txs'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.txs) ? [_c('tr', [_c('td', [_vm._v("Per block")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.0f', _vm.sum(coin).txs.block)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Per second")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.2f', _vm.sum(coin).txs.second)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Per hour")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.0f', _vm.sum(coin).txs.hour)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Per day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.0f', _vm.sum(coin).txs.day)))])
  })], 2)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('txfee')
      }
    }
  }, [(_vm.showstats.txfee) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.txfee) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Transaction fees\n                "), _c('small', [_vm._v("(24h averages)")])]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'tx.fee'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.txfee) ? [_c('tr', [_c('td', [_vm._v("Sat/B")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.2f', _vm.sum(coin).tx_fees.sat_b)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("USD/kB")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.money(_vm.sum(coin).tx_fees.usd_kb)))])
  })], 2)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('reward')
      }
    }
  }, [(_vm.showstats.reward) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.reward) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n            Average block reward\n          ")]), _vm._v(" "), _c('small', [_vm._v("\n                ("), _c('span', {
    class: {
      'rpa': _vm.rewardperiod == 'block'
    },
    on: {
      "click": function($event) {
        _vm.rewardperiod = 'block'
      }
    }
  }, [_vm._v("last block")]), _vm._v(",\n                "), _c('span', {
    class: {
      'rpa': _vm.rewardperiod == 'day'
    },
    on: {
      "click": function($event) {
        _vm.rewardperiod = 'day'
      }
    }
  }, [_vm._v("past day")]), _vm._v(",\n                "), _c('span', {
    class: {
      'rpa': _vm.rewardperiod == 'week'
    },
    on: {
      "click": function($event) {
        _vm.rewardperiod = 'week'
      }
    }
  }, [_vm._v("past week")]), _vm._v(")\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'reward.blocks'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.reward) ? [_c('tr', [_c('td', [_vm._v("Coinbase")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.money(_vm.rp(coin).coinbase / _vm.rpb(coin), false)) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fees")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.money(_vm.rp(coin).fees / _vm.rpb(coin), false)) + "\n                "), _c('small', [_vm._v("(" + _vm._s(_vm.sprintf('%.2f', _vm.rp(coin).fees_coin / _vm.rpb(coin))) + " " + _vm._s(coin) + ")")])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.money(_vm.rp(coin).total / _vm.rpb(coin), false)) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fee %")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v("\n                " + _vm._s(_vm.sprintf('%.2f%%', (_vm.rp(coin).fee_pct))) + "\n              ")])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("DARI")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rewardperiod === 'block'),
        expression: "rewardperiod === 'block'"
      }]
    }, [_vm._v(_vm._s(_vm.sprintf('%.2f', (_vm.sum(coin).dari.last))))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rewardperiod === 'day'),
        expression: "rewardperiod === 'day'"
      }]
    }, [_vm._v(_vm._s(_vm.sprintf('%.2f', (_vm.sum(coin).dari.day_1))))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rewardperiod === 'week'),
        expression: "rewardperiod === 'week'"
      }]
    }, [_vm._v(_vm._s(_vm.sprintf('%.2f', (_vm.sum(coin).dari.day_7))))])])
  })], 2)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('blocksize')
      }
    }
  }, [(_vm.showstats.blocksize) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.blocksize) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Average blocksize in kB\n                "), _c('small', [_vm._v("(excluding empty blocks)")])]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'blocks.size'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.blocksize) ? [_c('tr', [_c('td', [_vm._v("Today")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.2f', _vm.sum(coin).blocksize.day_1)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("-7 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.2f', _vm.sum(coin).blocksize.day_7)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("-30 day")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.2f', _vm.sum(coin).blocksize.day_30)))])
  })], 2)] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('retarget')
      }
    }
  }, [(_vm.showstats.retarget) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.retarget) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Difficulty retarget\n              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "chartlink",
    attrs: {
      "to": {
        name: 'pow.retarget'
      }
    }
  }, [_vm._v("chart")])], 1)]), _vm._v(" "), (_vm.showstats.retarget) ? [_c('tr', [_c('td', [_vm._v("Date (24h UTC)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.date('BTC')))]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Remaining")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.days('BTC')) + "\n                "), _c('small', [_vm._v("(" + _vm._s(_vm.left('BTC')) + " blk)")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Change")]), _vm._v(" "), _c('td', [(_vm.next_pct('BTC', true) > 1) ? _c('i', {
    staticClass: "fa fa-chevron-up green"
  }) : _vm._e(), _vm._v(" "), (_vm.next_pct('BTC', true) < 1) ? _c('i', {
    staticClass: "fa fa-chevron-down red"
  }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.next('BTC')) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("-")])])] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "summary-header",
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "toggle-stat",
    on: {
      "click": function($event) {
        _vm.toggle('halvening')
      }
    }
  }, [(_vm.showstats.halvening) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v(" "), (!_vm.showstats.halvening) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v("\n                Halvening\n                "), _c('small', [_vm._v("(based on blocks past 30 days)")])])])]), _vm._v(" "), (_vm.showstats.halvening) ? [_c('tr', [_c('td', [_vm._v("Blocks")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sum(coin).halvening.blocks))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Days")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.sprintf('%.0f', _vm.sum(coin).halvening.seconds / (24 * 3600))))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("New reward*")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.halvening_reward(coin)))])
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("New fee %**")]), _vm._v(" "), _vm._l((_vm.coins), function(coin) {
    return _c('td', [_vm._v(_vm._s(_vm.halvening_fees(coin)))])
  })], 2), _vm._v(" "), _vm._m(3, false, false)] : _vm._e()], 2)])])])]), _vm._v(" "), _c('small', [(_vm.showstats.halvening) ? [_c('feemarket')] : _vm._e()], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "noboto"
  }), _vm._v(" "), _c('td', {
    staticClass: "noboto"
  }, [_vm._v("BTC/USD")]), _vm._v(" "), _c('td', {
    staticClass: "noboto"
  }, [_vm._v("BCH/USD")]), _vm._v(" "), _c('td', {
    staticClass: "noboto"
  }, [_vm._v("BCH/BTC")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "noboto"
  }), _vm._v(" "), _c('td', {
    staticClass: "noboto",
    attrs: {
      "align": "center"
    }
  }, [_c('strong', [_vm._v("BTC")])]), _vm._v(" "), _c('td', {
    staticClass: "noboto",
    attrs: {
      "align": "center"
    }
  }, [_c('strong', [_vm._v("BCH")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('small', [_vm._v("\n                  * The average of the last 3 blocks is used to even out tx fees.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('small', [_vm._v("\n                  * Based on 30d average coinbase+fees with current exchange rate ** Income from fees as a percentage of the total block reward\n                ")])])])
}]}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Average blocksizes.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('stat-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-blocksize"
    }
  })])
}]}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Average amount of fees per block in USD.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('stat-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-fees"
    }
  })])
}]}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    BCH past month (or since hf if hf < 30 days)\n  ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    In the period from " + _vm._s(_vm.date_from) + " to " + _vm._s(_vm.date_to) + " a total number of " + _vm._s(_vm.blocks) + " blocks were mined.\n    This results in an average of "), _c('u', [_vm._v(_vm._s(_vm.blocktime) + " minutes")]), _vm._v("\n    to find a block.\n  ")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("\n      Average number of blocks per hour over the entire period (measured over " + _vm._s(_vm.interval / 60) + " minute intervals):\n      "), _c('table', {
    staticClass: "table table-sm table-bordered times-table"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Blocks:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['15']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['10']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['7']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['5']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['3']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['2']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['1']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['0']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Percentage:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('15')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('10')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('7')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('5')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('3')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('2')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('1')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('0')))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "times-high",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.block_times_high) + "\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "times-norm"
  }, [_vm._v("\n            " + _vm._s(_vm.block_times_norm) + "\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "times-low",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.block_times_low) + "\n          ")])])])])]), _vm._v(" "), _c('small', [_vm._v("\n      Number of blocks mined during periods of relative block reward per amount of work done compared to BTC.\n      "), _c('table', {
    staticClass: "table table-sm table-bordered times-table"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Blocks:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.vlow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.low))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.blocks_dari.norm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.high))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.vhigh))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Percentage:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('vlow')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('low')))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.dari_pct('norm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('high')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('vhigh')))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "times-high",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.sprintf('%.2f%%', _vm.dari_low / _vm.blocks * 100)))]), _vm._v(" "), _c('td', {
    staticClass: "times-norm",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.sprintf('%.2f%%', _vm.dari_high / _vm.blocks * 100)))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-daa"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark chead"
  }, [_c('tr', [_c('th', {
    staticClass: "noc"
  }, [_vm._v("Blocks/hr:")]), _vm._v(" "), _c('th', [_vm._v("15+")]), _vm._v(" "), _c('th', [_vm._v(">10-15")]), _vm._v(" "), _c('th', [_vm._v(">8-10")]), _vm._v(" "), _c('th', [_vm._v(">4-8")]), _vm._v(" "), _c('th', [_vm._v(">3-4")]), _vm._v(" "), _c('th', [_vm._v(">2-3")]), _vm._v(" "), _c('th', [_vm._v(">1-2")]), _vm._v(" "), _c('th', [_vm._v("<1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark chead"
  }, [_c('tr', [_c('th', {
    staticClass: "noc"
  }, [_vm._v("DARI ratio:")]), _vm._v(" "), _c('th', [_vm._v("< 0.7x")]), _vm._v(" "), _c('th', [_vm._v("0.7x - 0.9x")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("0.9x - 1.1x")]), _vm._v(" "), _c('th', [_vm._v("1.1x - 1.30x")]), _vm._v(" "), _c('th', [_vm._v("> 1.30x")])])])
}]}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Block height. " + _vm._s(_vm.height_diff_txt) + "\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-height"
    }
  })])
}]}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Average number of transactions per block.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('stat-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-txs"
    }
  })])
}]}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Sum of coindays destroyed in period (log scale).\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('stat-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-cdd"
    }
  })])
}]}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('small', [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Coin")]), _vm._v(" "), _vm._l((_vm.stats.header), function(h) {
    return _c('th', {
      key: h
    }, [_vm._v(_vm._s(h))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.stats.coins), function(g, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', [_vm._v(_vm._s(g.coin))]), _vm._v(" "), _vm._l((g.values), function(v, idxx) {
      return _c('td', {
        key: idx + '_' + idxx
      }, [_vm._v(_vm._s(_vm.stats.f(g.coin, v)))])
    })], 2)
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Average number of blocks found every hour.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("BTC")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BTC', '3h', 3 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BTC', '6h', 6 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BTC', '12h', 12 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BTC', '1d', 24 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BTC', '7d', 7 * 24 * 60)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BCH")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BCH', '3h', 3 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BCH', '6h', 6 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BCH', '12h', 12 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BCH', '1d', 24 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BCH', '7d', 7 * 24 * 60)))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "644px"
    },
    attrs: {
      "id": "canvas-blocktime"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Coin")]), _vm._v(" "), _c('th', [_vm._v("3h")]), _vm._v(" "), _c('th', [_vm._v("6h")]), _vm._v(" "), _c('th', [_vm._v("12h")]), _vm._v(" "), _c('th', [_vm._v("1d")]), _vm._v(" "), _c('th', [_vm._v("7d")])])])
}]}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    style: ({
      height: _vm.chart_height
    }),
    attrs: {
      "id": "canvas-feemarket"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Combined (sum of chain difficulties) expected difficulty based on hashrate versus actual difficulty.\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-difficulty-expected"
    }
  })]), _vm._v(" "), _c('br')])
}]}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'reward.dari'
      }
    }
  }, [_vm._v("DARI")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'reward.blocks'
      }
    }
  }, [_vm._v("Blocks")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'reward.fees'
      }
    }
  }, [_vm._v("Fees")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'reward.feepct'
      }
    }
  }, [_vm._v("Fee %")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'reward.inflation'
      }
    }
  }, [_vm._v("Inflation")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lol-window-chart"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('p', [_vm._v("\n        The sum of potentially missed rewards by BCH miners compared to what they could earn on the BTC chain. Combined, BCH miners have currently missed out on an estimated total of " + _vm._s(_vm.money(_vm.total_cap)) + ".\n    ")]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n        These numbers are based on blocks that were actually found and not only an estimation based on difficulty/hashrate. The hashrate (or\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'pow.speed'
      }
    }
  }, [_vm._v("speed")]), _vm._v(") is accounted for when calculating the difference. There is also a small compensation applied to fees to correct for loss of fee pressure. These numbers are not perfect, only an aproximation but they come close to reality.\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Also, this chart does not take into account the future gains in exchange rate of the coins. It assumes miners will sell the coins as soon as possible (hodling is not factored in ;)).\n    ")], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n            Once segwit activates on the BTC chain this chart cannot be constructed in a reliable manner anymore (it already is a bit iffy). The chains wil diverge too much to make a sensible comparison between the two. Once that happens this chart will be removed.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-opportunity"
    }
  })])
}]}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": 'canvas-hashrate-dari-' + _vm.avg
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    Estimated days for difficulty retarget.\n  ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_c('p', [_vm._v("\n      Estimated next difficulty. The 12 hour hashrate average is used to make a prediction about upcoming blocks in the period.\n    ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("BTC")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.date('BTC')))]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.days('BTC')) + "\n          "), _c('small', [_vm._v("(" + _vm._s(_vm.left('BTC')) + " blk)")])]), _vm._v(" "), _c('td', [(_vm.next_pct('BTC', true) > 1) ? _c('i', {
    staticClass: "fa fa-chevron-up up"
  }) : _vm._e(), _vm._v(" "), (_vm.next_pct('BTC', true) < 1) ? _c('i', {
    staticClass: "fa fa-chevron-down down"
  }) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.next('BTC')) + "\n        ")])]), _vm._v(" "), _vm._m(2, false, false)])]), _vm._v("\n    * On November 13th 2017 BCH switches to a faster changing difficulty algorithm which makes it impractical to make predictions about its behaviour.\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-retarget"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Coin")]), _vm._v(" "), _c('th', [_vm._v("Date (UTC 24h)")]), _vm._v(" "), _c('th', [_vm._v("Remaining")]), _vm._v(" "), _c('th', [_vm._v("Change")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("BCH *")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])])
}]}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": 'canvas-algo-' + _vm.coin
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    In the period from " + _vm._s(_vm.date_from) + " to " + _vm._s(_vm.date_to) + " a total number of " + _vm._s(_vm.blocks) + " blocks were mined.\n    This results in an average of "), _c('u', [_vm._v(_vm._s(_vm.blocktime) + " minutes")]), _vm._v("\n    to find a block.\n  ")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("\n      Average number of blocks per hour over the entire period (measured over " + _vm._s(_vm.interval / 60) + " minute intervals):\n      "), _c('table', {
    staticClass: "table table-sm table-bordered times-table"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Blocks:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['15']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['10']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['7']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['5']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['3']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['2']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['1']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['0']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Percentage:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('15')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('10')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('7')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('5')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('3')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('2')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('1')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('0')))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "times-high",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.block_times_high) + "\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "times-norm"
  }, [_vm._v("\n            " + _vm._s(_vm.block_times_norm) + "\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "times-low",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.block_times_low) + "\n          ")])])])])]), _vm._v(" "), _c('small', [_vm._v("\n      Number of blocks mined during periods of relative block reward per amount of work done compared to " + _vm._s(_vm.coino(_vm.coin)) + ".\n      "), _c('table', {
    staticClass: "table table-sm table-bordered times-table"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Blocks:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.vlow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.low))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.blocks_dari.norm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.high))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.vhigh))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Percentage:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('vlow')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('low')))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.dari_pct('norm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('high')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('vhigh')))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "times-high",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.sprintf('%.2f%%', _vm.dari_low / _vm.blocks * 100)))]), _vm._v(" "), _c('td', {
    staticClass: "times-norm",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.sprintf('%.2f%%', _vm.dari_high / _vm.blocks * 100)))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark chead"
  }, [_c('tr', [_c('th', {
    staticClass: "noc"
  }, [_vm._v("Blocks/hr:")]), _vm._v(" "), _c('th', [_vm._v("15+")]), _vm._v(" "), _c('th', [_vm._v(">10-15")]), _vm._v(" "), _c('th', [_vm._v(">8-10")]), _vm._v(" "), _c('th', [_vm._v(">4-8")]), _vm._v(" "), _c('th', [_vm._v(">3-4")]), _vm._v(" "), _c('th', [_vm._v(">2-3")]), _vm._v(" "), _c('th', [_vm._v(">1-2")]), _vm._v(" "), _c('th', [_vm._v("<1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark chead"
  }, [_c('tr', [_c('th', {
    staticClass: "noc"
  }, [_vm._v("DARI ratio:")]), _vm._v(" "), _c('th', [_vm._v("< 0.7x")]), _vm._v(" "), _c('th', [_vm._v("0.7x - 0.9x")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("0.9x - 1.1x")]), _vm._v(" "), _c('th', [_vm._v("1.1x - 1.30x")]), _vm._v(" "), _c('th', [_vm._v("> 1.30x")])])])
}]}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    Normalized miner income for work done (DARI)\n  ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    With this result we can compare the two chains. For example, using the DARI of the last block we can estimate that a " + _vm._s(_vm.leader) + " miner could potentially collect (" + _vm._s(_vm.dari(_vm.leader)) + " / " + _vm._s(_vm.dari(_vm.loser)) + " =)\n    "), _c('strong', [_vm._v(_vm._s(_vm.leader_ratio))]), _vm._v(" times the reward (in USD) that a " + _vm._s(_vm.loser) + " miner could collect.\n  ")]), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills justify-content-center small"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'reward.dari.btc'
      }
    }
  }, [_vm._v("BTC")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'reward.dari.bch'
      }
    }
  }, [_vm._v("BCH")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-dari"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    The DARI (Difficulty Adjusted Reward Index) is a way to compare the rewards of two chains that share the same reward system. The following calculation is used to determine the DARI:\n    "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('code', [_vm._v("\n      (block coinbase+fees in satoshis) / (block difficulty) * (exchange rate in USD)\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    Since the inception of BCH we have seen that some miners switch based on which coin is most rewarding for the work they perform.\n    The data below is an attempt to capture some of the effects of this so called \"chain hopping\".\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n    Whether the chain hopping actually results in more income for a miner depends on many factors. Most notably the pool\n    "), _c('a', {
    attrs: {
      "href": "https://en.bitcoin.it/wiki/Comparison_of_mining_pools",
      "target": "_blank"
    }
  }, [_vm._v("reward type")]), _vm._v(", the exchange rate\n    (since coins need to mature 100 blocks before they can be spent), the cash out strategy of the miner and of course plain old luck :)\n  ")])
}]}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Total hashrate during times when DARI is highest. Orange line means BTC DARI was highest, blue means BCH DARI was highest. \n    ")]), _vm._v("\n\n    7 day rolling average\n    "), _c('hashrate-dari', {
    attrs: {
      "avg": "rate7d"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n    3 day rolling average\n    "), _c('hashrate-dari', {
    attrs: {
      "avg": "rate3d"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n    1 day rolling average\n    "), _c('hashrate-dari', {
    attrs: {
      "avg": "rate1d"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n    12 hour rolling average\n    "), _c('hashrate-dari', {
    attrs: {
      "avg": "rate12h"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n    3 hour rolling average\n    "), _c('hashrate-dari', {
    attrs: {
      "avg": "rate3h"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    attrs: {
      "id": "exp"
    }
  }, [_vm._v("\n        Block difficulty.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n        The BCH chain is currently running at\n        "), _c('strong', [_vm._v(_vm._s(_vm.sprintf('%.2f', _vm.data.BCH.averages.last.avg_diff / _vm.data.BTC.averages.last.avg_diff * 100)) + "%")]), _vm._v(" difficulty compared to the BTC chain.\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('expected')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-difficulty"
    }
  })])
}]}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "contact"
  }, [_c('h3', [_vm._v("Contact")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Questions, issues or suggestions?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('dt', [_vm._v("Email")]), _vm._v(" "), _c('dd', [_vm._v("cixx@cyberdyne.sh")]), _vm._v(" "), _c('dt', [_vm._v("IRC")]), _vm._v(" "), _c('dd', [_vm._v("#forklol on freenode")]), _vm._v(" "), _c('dt', [_vm._v("Slack")]), _vm._v(" "), _c('dd', [_vm._v("trippysalmon on bitcoincore.slack.com")]), _vm._v(" "), _c('dt', [_vm._v("Twitter")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "https://twitter.com/trippysalmon"
    }
  }, [_vm._v("@trippysalmon")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Donations")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-around text-center"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('p', [_vm._v("Donate Bitcoin:")]), _vm._v(" "), _c('p', [_vm._v("1F43wkTWaUVyDbtfJrHXpc3C1ek5kcK8A")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "bitcoin:1F43wkTWaUVyDbtfJrHXpc3C1ek5kcK8A"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/qr_btc.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("(image is clickable)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "hidden-md-up"
  }, [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', [_vm._v("Donate Bitcoin Cash:")]), _vm._v(" "), _c('p', [_vm._v("1BFeA4phuDxfh4nqnRk9tjzYt9viQEvQkq")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/qr_bch.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])])
}]}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    Total inflation since fork and inflation rate.\n  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-inflation"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    The chart is composed of 256 chunks of data in the past 30 days. The inflation rate is therefore calculated over a 1/256 period in that timeframe. The total inflation is calculated over all data since the BCH fork.\n  ")])])
}]}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    style: ({
      height: _vm.chart_height
    }),
    attrs: {
      "id": "canvas-rdari"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Proof of work equivalent days to rewrite the BCH chain from moment of fork. A 3 day average is used to determine hashrate.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n        The ratio of total work since the split divided by estimate of hashrates at that time. The 5%, 10% and 25% are percentages of global hashpower. For example, it will take about " + _vm._s(_vm.replace_chain) + " for hashpower equivalent to that of BTC to rewrite the BCH chain from moment of fork until now. For a miner with 25% hashpower it will take about " + _vm._s(_vm.replace_chain_rate(0.25)) + ".\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-attack"
    }
  })])
}]}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'blocks.time'
      }
    }
  }, [_vm._v("Blocks/hr")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'blocks.size'
      }
    }
  }, [_vm._v("Blocksize")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'blocks.height'
      }
    }
  }, [_vm._v("Height")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'blocks.cdd'
      }
    }
  }, [_vm._v("Coindays")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lol-window-chart"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'pow.hashrate'
      }
    }
  }, [_vm._v("Hashrate")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'pow.work'
      }
    }
  }, [_vm._v("Total work")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'pow.retarget'
      }
    }
  }, [_vm._v("Retarget")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'pow.speed'
      }
    }
  }, [_vm._v("Speed")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'pow.difficulty'
      }
    }
  }, [_vm._v("Difficulty")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lol-window-chart"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Fee percentage contributing to total reward (calculated in USD).\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('stat-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-feepct"
    }
  })])
}]}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pre', [_vm._v(_vm._s(_vm.data.BCH.summary))]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.data.BTC.summary))]), _vm._v(" "), _c('p', [_vm._v("\n    Mining profitability based on fees, exchange rate and mining difficulty.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col col-xl-7 col-lg-8 col-md-8"
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('tbody', [_c('tr', {
    class: {
      'bgdarilead': _vm.leader == 'BTC'
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _c('td', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BTC', 'BCH', 'last', true))
    }
  })]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BTC', 'BCH', '6h'))
    }
  }), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BTC', 'BCH', '1d'))
    }
  }), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BTC', 'BCH', '7d'))
    }
  })]), _vm._v(" "), _c('tr', {
    class: {
      'bgdarilead': _vm.leader == 'BCH'
    }
  }, [_vm._m(2, false, false), _vm._v(" "), _c('td', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BCH', 'BTC', 'last', true))
    }
  })]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BCH', 'BTC', '6h'))
    }
  }), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BCH', 'BTC', '1d'))
    }
  }), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.dari_period('BCH', 'BTC', '7d'))
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col col-xl-12 col-lg-12 col-md-12 col-sm-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('small', [(!_vm.empty_any) ? [_vm._v("\n              * Based on the last block and exchange rates " + _vm._s(_vm.money(_vm.data.BTC.averages.last.price))), _c('sup', [_vm._v("BTC")]), _vm._v("\n              " + _vm._s(_vm.money(_vm.data.BCH.averages.last.price))), _c('sup', [_vm._v("BCH")])] : [_vm._v("\n              * Empty BTC or BCH block found, skipping calculations.\n            ")]], 2)]), _vm._v(" "), _vm._m(3, false, false)])])]), _vm._v(" "), _c('dari'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4, false, false)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "trfirst"
  }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("current*")]), _vm._v(" "), _c('th', [_vm._v("6h"), _c('sup', [_vm._v("avg")])]), _vm._v(" "), _c('th', [_vm._v("1d"), _c('sup', [_vm._v("avg")])]), _vm._v(" "), _c('th', [_vm._v("7d"), _c('sup', [_vm._v("avg")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("BTC")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("BCH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('small')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Recent changes")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-lightbulb-o fac"
  }), _vm._v("\n        Only show past 30 days in charts. I will bring longer (and shorter) time ranges back at a later point in time. The B2X fork \"suspension\" made me spend a lot of development time in vain and I now need make some changes before I can put the new updates online. Stay tuned.\n      ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-lightbulb-o fac"
  }), _vm._v("\n        Removed BCH difficulty retarget prediction ("), _c('a', {
    attrs: {
      "href": "https://www.bitcoinabc.org/november",
      "target": "_blank"
    }
  }, [_vm._v("info")]), _vm._v(")\n      ")])])])])
}]}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hra'), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("BTC")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.perct('BTC', '3h')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.perct('BTC', '12h')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.perct('BTC', '1d')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.perct('BTC', '3d')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.perct('BTC', '7d')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BCH")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.perct('BCH', '3h')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.perct('BCH', '12h')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.perct('BCH', '1d')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.perct('BCH', '3d')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.perct('BCH', '7d')))])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Relative hashrate in percentage of total (stacked, "), _c('u', [_vm._v("3h averages")]), _vm._v(").\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-hashrate"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Disclaimer: Please note that using a "), _c('u', [_vm._v("3 hour average")]), _vm._v(" is not the most reliable way of measuring this data. This data should be interpreted as an "), _c('u', [_vm._v("estimate")]), _vm._v(". The real number can differ by several percent.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Coin")]), _vm._v(" "), _c('th', [_vm._v("3h")]), _vm._v(" "), _c('th', [_vm._v("12h")]), _vm._v(" "), _c('th', [_vm._v("1d")]), _vm._v(" "), _c('th', [_vm._v("3d")]), _vm._v(" "), _c('th', [_vm._v("7d")])])])
}]}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Average block reward (coinbase+fees) in USD.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('stat-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-reward"
    }
  })])
}]}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Average tx fee in satoshis per byte.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('stat-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-txfee-sat"
    }
  })])
}]}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    BTC past month (or since BCH hf if hf < 30 days)\n  ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n    In the period from " + _vm._s(_vm.date_from) + " to " + _vm._s(_vm.date_to) + " a total number of " + _vm._s(_vm.blocks) + " blocks were mined.\n    This results in an average of "), _c('u', [_vm._v(_vm._s(_vm.blocktime) + " minutes")]), _vm._v("\n    to find a block.\n  ")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("\n      Average number of blocks per hour over the entire period (measured over " + _vm._s(_vm.interval / 60) + " minute intervals):\n      "), _c('table', {
    staticClass: "table table-sm table-bordered times-table"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Blocks:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['15']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['10']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['7']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['5']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['3']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['2']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['1']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times['0']))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Percentage:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('15')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('10')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('7')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('5')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('3')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('2')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('1')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.times_pct('0')))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "times-high",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.block_times_high) + "\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "times-norm"
  }, [_vm._v("\n            " + _vm._s(_vm.block_times_norm) + "\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "times-low",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.block_times_low) + "\n          ")])])])])]), _vm._v(" "), _c('small', [_vm._v("\n      Number of blocks mined during periods of relative block reward per amount of work done compared to BCH.\n      "), _c('table', {
    staticClass: "table table-sm table-bordered times-table"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Blocks:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.vlow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.low))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.blocks_dari.norm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.high))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_dari.vhigh))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noc"
  }, [_vm._v("Percentage:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('vlow')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('low')))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.dari_pct('norm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('high')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dari_pct('vhigh')))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "times-high",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.sprintf('%.2f%%', _vm.dari_low / _vm.blocks * 100)))]), _vm._v(" "), _c('td', {
    staticClass: "times-norm",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.sprintf('%.2f%%', _vm.dari_high / _vm.blocks * 100)))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-daa"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark chead"
  }, [_c('tr', [_c('th', {
    staticClass: "noc"
  }, [_vm._v("Blocks/hr:")]), _vm._v(" "), _c('th', [_vm._v("15+")]), _vm._v(" "), _c('th', [_vm._v(">10-15")]), _vm._v(" "), _c('th', [_vm._v(">8-10")]), _vm._v(" "), _c('th', [_vm._v(">4-8")]), _vm._v(" "), _c('th', [_vm._v(">3-4")]), _vm._v(" "), _c('th', [_vm._v(">2-3")]), _vm._v(" "), _c('th', [_vm._v(">1-2")]), _vm._v(" "), _c('th', [_vm._v("<1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark chead"
  }, [_c('tr', [_c('th', {
    staticClass: "noc"
  }, [_vm._v("DARI ratio:")]), _vm._v(" "), _c('th', [_vm._v("< 0.7x")]), _vm._v(" "), _c('th', [_vm._v("0.7x - 0.9x")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("0.9x - 1.1x")]), _vm._v(" "), _c('th', [_vm._v("1.1x - 1.30x")]), _vm._v(" "), _c('th', [_vm._v("> 1.30x")])])])
}]}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'security.fork'
      }
    }
  }, [_vm._v("Fork rewrite")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'security.chain'
      }
    }
  }, [_vm._v("Chain rewrite")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lol-window-chart"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(0, false, false)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _vm._v("The idea for these charts originate from Pieter Wuille. \n        See "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://bitcoin.sipa.be/index.html"
    }
  }, [_vm._v("bitcoin.sipa.be")]), _vm._v(" \"Proof of Work Equivalent Days\".\n    ")])
}]}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    Relative speed of blocks found compared to the target of 6 blocks per hour (although the 6 blocks per hour is only a proxy for the actual target of 2016 blocks every two weeks).\n  ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('stat-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-speed"
    }
  })])
}]}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.loaded === false) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n    Loading data..\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/logo.png",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card lol-window"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'reward'
      }
    }
  }, [_vm._v("Reward")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'blocks'
      }
    }
  }, [_vm._v("Blocks")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'tx'
      }
    }
  }, [_vm._v("Tx")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'pow'
      }
    }
  }, [_vm._v("POW")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'security'
      }
    }
  }, [_vm._v("Security")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "lol-window-inner"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-muted text-center"
  }, [_vm._v("\n              created by\n              "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("trippysalmon")]), _vm._v("\n              / " + _vm._s(_vm.version) + " / blockdata kindly provided by\n              "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://blockchair.com"
    }
  }, [_vm._v("blockchair.com")]), _vm._v(" / exchange rate by\n              "), _c('a', {
    attrs: {
      "href": "http://www.bitcoinaverage.com"
    }
  }, [_vm._v("bitcoinaverage.com")])], 1)])])])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('notifications')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-light bg-faded lol-nav"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/logo.png",
      "alt": "fork.lol",
      "width": "30",
      "height": "30"
    }
  }), _vm._v(" fork.lol\n      ")])])
}]}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'tx.txs'
      }
    }
  }, [_vm._v("Tx count")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'tx.fee'
      }
    }
  }, [_vm._v("Tx fee (sat)")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lol-window-chart"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"-","unitSeparator":"and ","base":{"0":"zero","1":"one","2":"two","3":"three","4":"four","5":"five","6":"six","7":"seven","8":"eight","9":"nine","10":"ten","11":"eleven","12":"twelve","13":"thirteen","14":"fourteen","15":"fifteen","16":"sixteen","17":"seventeen","18":"eighteen","19":"nineteen","20":"twenty","30":"thirty","40":"forty","50":"fifty","60":"sixty","70":"seventy","80":"eighty","90":"ninety"},"units":{"2":"hundred","3":"thousand","5":"lakh","7":"crore"},"unitExceptions":[]}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"-","unitSeparator":"and ","base":{"0":"zero","1":"one","2":"two","3":"three","4":"four","5":"five","6":"six","7":"seven","8":"eight","9":"nine","10":"ten","11":"eleven","12":"twelve","13":"thirteen","14":"fourteen","15":"fifteen","16":"sixteen","17":"seventeen","18":"eighteen","19":"nineteen","20":"twenty","30":"thirty","40":"forty","50":"fifty","60":"sixty","70":"seventy","80":"eighty","90":"ninety"},"units":["hundred","thousand","million","billion","trillion","quadrillion","quintillion","sextillion","septillion","octillion","nonillion","decillion","undecillion","duodecillion","tredecillion","quattuordecillion","quindecillion"],"unitExceptions":[]}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" ","unitSeparator":"","base":{"0":"nulo","1":"unu","2":"du","3":"tri","4":"kvar","5":"kvin","6":"ses","7":"sep","8":"ok","9":"naŭ","10":"dek","20":"dudek","30":"tridek","40":"kvardek","50":"kvindek","60":"sesdek","70":"sepdek","80":"okdek","90":"naŭdek","100":"cent","200":"ducent","300":"tricent","400":"kvarcent","500":"kvincent","600":"sescent","700":"sepcent","800":"okcent","900":"naŭcent"},"units":[{"useBaseInstead":true,"useBaseException":[]},{"singular":"mil","avoidPrefixException":[1]},{"singular":"miliono","plural":"milionoj","avoidPrefixException":[1]},{"singular":"miliardo","plural":"miliardoj","avoidPrefixException":[1]},{"singular":"biliono","plural":"bilionoj","avoidPrefixException":[1]}],"unitExceptions":[]}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":true,"baseSeparator":" y ","unitSeparator":"","base":{"0":"cero","1":"uno","2":"dos","3":"tres","4":"cuatro","5":"cinco","6":"seis","7":"siete","8":"ocho","9":"nueve","10":"diez","11":"once","12":"doce","13":"trece","14":"catorce","15":"quince","16":"dieciséis","17":"diecisiete","18":"dieciocho","19":"diecinueve","20":"veinte","21":"veintiuno","22":"veintidós","23":"veintitrés","24":"veinticuatro","25":"veinticinco","26":"veintiséis","27":"veintisiete","28":"veintiocho","29":"veintinueve","30":"treinta","40":"cuarenta","50":"cincuenta","60":"sesenta","70":"setenta","80":"ochenta","90":"noventa","100":"cien","200":"doscientos","300":"trescientos","400":"cuatrocientos","500":"quinientos","600":"seiscientos","700":"setecientos","800":"ochocientos","900":"novecientos","1000":"mil"},"unitExceptions":{"1":"un"},"units":[{"singular":"ciento","useBaseInstead":true,"useBaseException":[1]},{"singular":"mil","avoidPrefixException":[1]},{"singular":"millón","plural":"millones"},{"singular":"billón","plural":"billones"},{"singular":"trillón","plural":"trillones"},{"singular":"cuatrillón","plural":"cuatrillones"},{"singular":"quintillón","plural":"quintillones"},{"singular":"sextillón","plural":"sextillones"},{"singular":"septillón","plural":"septillones"},{"singular":"octillón","plural":"octillones"},{"singular":"nonillón","plural":"nonillones"},{"singular":"decillón","plural":"decillones"},{"singular":"undecillón","plural":"undecillones"},{"singular":"duodecillón","plural":"duodecillones"},{"singular":"tredecillón","plural":"tredecillones"},{"singular":"cuatrodecillón","plural":"cuatrodecillones"},{"singular":"quindecillón","plural":"quindecillones"}]}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"-","unitSeparator":"","base":{"0":"zéro","1":"un","2":"deux","3":"trois","4":"quatre","5":"cinq","6":"six","7":"sept","8":"huit","9":"neuf","10":"dix","11":"onze","12":"douze","13":"treize","14":"quatorze","15":"quinze","16":"seize","17":"dix-sept","18":"dix-huit","19":"dix-neuf","20":"vingt","30":"trente","40":"quarante","50":"cinquante","60":"soixante","70":"soixante-dix","80":"quatre-vingt","90":"quatre-vingt-dix"},"units":[{"singular":"cent","plural":"cents","avoidInNumberPlural":true,"avoidPrefixException":[1]},{"singular":"mille","avoidPrefixException":[1]},{"singular":"million","plural":"millions"},{"singular":"milliard","plural":"milliards"},{"singular":"billion","plural":"billions"},{"singular":"billiard","plural":"billiards"},{"singular":"trillion","plural":"trillions"},{"singular":"trilliard","plural":"trilliards"},{"singular":"quadrillion","plural":"quadrillions"},{"singular":"quadrilliard","plural":"quadrilliards"},{"singular":"quintillion","plural":"quintillions"},{"singular":"quintilliard","plural":"quintilliards"},{"singular":"sextillion","plural":"sextillions"},{"singular":"sextilliard","plural":"sextilliards"},{"singular":"septillion","plural":"septillions"},{"singular":"septilliard","plural":"septilliards"},{"singular":"octillion","plural":"octillions"}],"unitExceptions":{"71":"soixante et onze","72":"soixante-douze","73":"soixante-treize","74":"soixante-quatorze","75":"soixante-quinze","76":"soixante-seize","77":"soixante-dix-sept","78":"soixante-dix-huit","79":"soixante-dix-neuf","80":"quatre-vingts","91":"quatre-vingt-onze","92":"quatre-vingt-douze","93":"quatre-vingt-treize","94":"quatre-vingt-quatorze","95":"quatre-vingt-quinze","96":"quatre-vingt-seize","97":"quatre-vingt-dix-sept","98":"quatre-vingt-dix-huit","99":"quatre-vingt-dix-neuf"}}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":"","unitSeparator":"","generalSeparator":"","wordSeparator":"","base":{"0":"zero","1":"uno","2":"due","3":"tre","4":"quattro","5":"cinque","6":"sei","7":"sette","8":"otto","9":"nove","10":"dieci","11":"undici","12":"dodici","13":"tredici","14":"quattordici","15":"quindici","16":"sedici","17":"diciassette","18":"diciotto","19":"diciannove","20":"venti","21":"ventuno","23":"ventitré","28":"ventotto","30":"trenta","31":"trentuno","33":"trentatré","38":"trentotto","40":"quaranta","41":"quarantuno","43":"quaranta­tré","48":"quarantotto","50":"cinquanta","51":"cinquantuno","53":"cinquantatré","58":"cinquantotto","60":"sessanta","61":"sessantuno","63":"sessanta­tré","68":"sessantotto","70":"settanta","71":"settantuno","73":"settantatré","78":"settantotto","80":"ottanta","81":"ottantuno","83":"ottantatré","88":"ottantotto","90":"novanta","91":"novantuno","93":"novantatré","98":"novantotto","100":"cento","101":"centuno","108":"centootto","180":"centottanta","201":"duecentuno","301":"tre­cent­uno","401":"quattro­cent­uno","501":"cinque­cent­uno","601":"sei­cent­uno","701":"sette­cent­uno","801":"otto­cent­uno","901":"nove­cent­uno"},"unitExceptions":{"1":"un"},"units":[{"singular":"cento","avoidPrefixException":[1]},{"singular":"mille","plural":"mila","avoidPrefixException":[1]},{"singular":"milione","plural":"milioni"},{"singular":"miliardo","plural":"miliardi"},{"singular":"bilione","plural":"bilioni"},{"singular":"biliardo","plural":"biliardi"},{"singular":"trilione","plural":"trilioni"},{"singular":"triliardo","plural":"triliardi"},{"singular":"quadrilione","plural":"quadrilioni"},{"singular":"quadriliardo","plural":"quadriliardi"}]}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" e ","unitSeparator":"e ","andWhenTrailing":true,"base":{"0":"zero","1":"um","2":"dois","3":"três","4":"quatro","5":"cinco","6":"seis","7":"sete","8":"oito","9":"nove","10":"dez","11":"onze","12":"doze","13":"treze","14":"catorze","15":"quinze","16":"dezasseis","17":"dezassete","18":"dezoito","19":"dezenove","20":"vinte","30":"trinta","40":"quarenta","50":"cinquenta","60":"sessenta","70":"setenta","80":"oitenta","90":"noventa","100":"cem","200":"duzentos","300":"trezentos","400":"quatrocentos","500":"quinhentos","600":"seiscentos","700":"setecentos","800":"oitocentos","900":"novecentos","1000":"mil"},"unitExceptions":{"1":"um"},"units":[{"singular":"cento","useBaseInstead":true,"useBaseException":[1],"useBaseExceptionWhenNoTrailingNumbers":true,"andException":true},{"singular":"mil","avoidPrefixException":[1],"andException":true},{"singular":"milhão","plural":"milhões"},{"singular":"bilhão","plural":"bilhões"},{"singular":"trilhão","plural":"trilhões"},{"singular":"quadrilhão","plural":"quadrilhão"},{"singular":"quintilhão","plural":"quintilhões"},{"singular":"sextilhão","plural":"sextilhões"},{"singular":"septilhão","plural":"septilhões"},{"singular":"octilhão","plural":"octilhões"},{"singular":"nonilhão","plural":"nonilhões"},{"singular":"decilhão","plural":"decilhões"},{"singular":"undecilhão","plural":"undecilhões"},{"singular":"doudecilhão","plural":"doudecilhões"},{"singular":"tredecilhão","plural":"tredecilhões"}]}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = {"useLongScale":false,"baseSeparator":" ","unitSeparator":"và ","base":{"0":"không","1":"một","2":"hai","3":"ba","4":"bốn","5":"năm","6":"sáu","7":"bảy","8":"tám","9":"chín","10":"mười","15":"mười lăm","20":"hai mươi","21":"hai mươi mốt","25":"hai mươi lăm","30":"ba mươi","31":"ba mươi mốt","40":"bốn mươi","41":"bốn mươi mốt","45":"bốn mươi lăm","50":"năm mươi","51":"năm mươi mốt","55":"năm mươi lăm","60":"sáu mươi","61":"sáu mươi mốt","65":"sáu mươi lăm","70":"bảy mươi","71":"bảy mươi mốt","75":"bảy mươi lăm","80":"tám mươi","81":"tám mươi mốt","85":"tám mươi lăm","90":"chín mươi","91":"chín mươi mốt","95":"chín mươi lăm"},"units":["trăm","ngàn","triệu","tỷ","nghìn tỷ"],"unitExceptions":[]}

/***/ })
]),[342]);


// WEBPACK FOOTER //
// static/js/forklol.818459431d587b186ce5.js